// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `img {
  max-width: 100%;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.dir-col {
  flex-direction: column;
}

.dir-col-rev {
  flex-direction: column-reverse;
}

.mh-full {
  min-height: 100%;
}

.mt-auto {
  margin-top: auto;
}

.bt-0 {
  border-top: 0;
}

.bb-0 {
  border-bottom: 0;
}

.fn-body h1,
.fn-body h2,
.fn-body h3,
.fn-body h4,
.fn-body h5,
.fn-body h6 {
  --hGap: 10px;
  font-family: "Museo-700";
  color: #6d6e71;
  margin-bottom: var(--hGap);
  margin-top: 0;
}
.fn-body h1:last-child,
.fn-body h2:last-child,
.fn-body h3:last-child,
.fn-body h4:last-child,
.fn-body h5:last-child,
.fn-body h6:last-child {
  margin-bottom: 0;
}
.fn-body h1,
.fn-body .h1-text {
  font-size: 44px;
  line-height: 1.1;
}
@media only screen and (max-width: 767px) {
  .fn-body h1,
  .fn-body .h1-text {
    font-size: 38px;
  }
}
.fn-body h2,
.fn-body .h2-text {
  font-size: 38px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h2,
  .fn-body .h2-text {
    font-size: 32px;
  }
}
.fn-body h3,
.fn-body .h3-text {
  font-size: 32px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h3,
  .fn-body .h3-text {
    font-size: 24px;
  }
}
.fn-body h4,
.fn-body .h4-text {
  font-size: 24px;
  line-height: 1.2;
}
.fn-body h5,
.fn-body .h5-text {
  font-size: 18px;
  line-height: 1.2;
}
.fn-body h6,
.fn-body .h6-text {
  font-size: 16px;
  line-height: 1.3;
}
.fn-body p {
  font-size: 18px;
  line-height: 1.6;
  color: #6a6a6a;
  margin-top: 0;
  margin-bottom: 10px;
}
.fn-body p:last-child {
  margin-bottom: 0;
}
@media only screen and (max-width: 767px) {
  .fn-body p {
    font-size: 16px;
  }
}
.fn-body ul,
.fn-body ol {
  padding: 0;
  margin: 0;
}
.fn-body sup {
  font-size: 0.7em;
  position: relative;
  top: 5px;
  display: inline-block;
  vertical-align: top;
}

.bg-grey {
  background-color: #eee;
}

.fn-container {
  max-width: 1080px;
  width: calc(100% - 30px);
  margin-inline: auto;
}
@media only screen and (min-width: 992px) {
  .fn-container {
    margin-left: 0;
  }
}
.fn-container--fluid {
  max-width: 1200px;
}
.fn-container--small {
  max-width: 820px;
  width: 100%;
}

.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}

.d-none {
  display: none;
}

.section-title {
  text-align: center;
}
.section-title:not(:last-child) {
  margin-bottom: 40px;
}
.section-title h2:not(:last-child) {
  margin-block-end: 20px;
}
.section-title p {
  max-width: 900px;
  width: 100%;
  margin-inline: auto;
  font-size: 22px;
}
.section-title p:not(:last-child) {
  margin-block-end: 20px;
}
@media only screen and (max-width: 767px) {
  .section-title p {
    font-size: 18px;
  }
}
.section-title .section-title__linkcontainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.section-title .section-title__linkcontainer:not(:last-child) {
  margin-block-end: 20px;
}
.section-title .section-title__linkcontainer > * {
  margin: 5px;
}
.section-title .section-title__linkcontainer .fn-btn {
  padding-block: 6px;
  padding-inline: 13px;
  font-size: 12px;
  font-family: "MuseoSans-300";
}

.section-padding {
  padding-block: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding {
    padding-block: 40px;
  }
}
.section-padding-small {
  padding-block: 30px;
}
.section-padding-all {
  padding: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding-all {
    padding: 30px;
  }
}
.section-padding-all-small {
  padding: 30px;
}

.headline {
  --lineSize: 10px;
  width: -moz-fit-content;
  width: fit-content;
  padding-block-end: calc(10px + var(--lineSize));
  margin-inline: auto;
  position: relative;
}
.headline--small-border {
  --lineSize: 6px;
}
.headline:not(:last-child) {
  margin-bottom: calc(var(--hGap) * 2.5);
}
.headline::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: var(--lineSize);
  background: linear-gradient(90deg, rgb(0, 173, 208) 0%, rgb(0, 173, 208) 25%, rgb(255, 121, 0) 25%, rgb(255, 121, 0) 50%, rgb(105, 190, 40) 50%, rgb(105, 190, 40) 75%, rgb(245, 67, 89) 75%, rgb(245, 67, 89) 100%);
}

.custom-list li {
  font-size: 18px;
  line-height: 1.4;
  color: #6a6a6a;
  list-style: none;
  position: relative;
  padding-left: 15px;
}
.custom-list li:not(:last-child) {
  margin-bottom: 4px;
}
.custom-list li::before {
  content: "";
  position: absolute;
  top: 10px;
  left: 0;
  width: 3px;
  height: 3px;
  background-color: var(--clrProfile);
}

.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.fn-btn {
  padding-block: 20px;
  padding-inline: 28px;
  background-color: rgb(105, 190, 40);
  color: #fff;
  font-size: 18px;
  line-height: 1.2;
  display: inline-block;
  font-family: "Museo-700";
  text-decoration: none;
  word-break: break-all;
  text-align: center;
  transition: background-color 0.3s;
}
.fn-btn:focus {
  outline: 1px dashed #6a6a6a;
  outline-offset: 4px;
}
.fn-btn:hover {
  background-color: #6d6e71;
  color: #fff;
}
.fn-btn--sm {
  font-size: 14px;
  padding-block: 10px;
  padding-inline: 20px;
}
.fn-btn--grey {
  background-color: #f1f1f2;
  color: #6d6e71;
}
.fn-btn--ongoing {
  background-color: #f8ac59;
  color: #fff;
}
.fn-btn--ongoing i {
  animation: spin 0.3s infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.w-4 {
  width: 33.3333333333%;
}

.w-3 {
  width: 25%;
}
.w-3--wd {
  width: 33.3333333333%;
}

.w-6 {
  width: 50%;
}

.fn-row {
  --rGap: 15px;
  --rGap-minus: calc(-1 * var(--rGap));
  display: flex;
  flex-wrap: wrap;
  margin-inline: var(--rGap-minus);
}
.fn-row--col-gap-exist .fn-col {
  margin-bottom: 30px;
}
.fn-col {
  padding-inline: var(--rGap);
}
.fn-justify-center {
  justify-content: center;
}
.fn-items-center {
  align-items: center;
}

.mx-auto {
  margin-inline: auto;
}
.ml-auto {
  margin-inline-start: auto;
}
.ml-0 {
  margin-inline-start: 0;
}
.mr-auto {
  margin-inline-end: auto;
}
.mr-0 {
  margin-inline-end: 0;
}

.ct-page {
  padding: 0 48px 48px;
  max-width: 1400px;
}
@media (max-width: 991px) {
  .ct-page {
    padding: 0 28px 36px;
  }
}
@media (max-width: 640px) {
  .ct-page {
    padding: 0 16px 28px;
  }
}

.ct-breadcrumb {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 16px 0;
  font-size: 13px;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  color: #676a6c;
  flex-wrap: wrap;
}
.ct-breadcrumb__link {
  color: #676a6c;
  text-decoration: none;
  transition: color 0.15s;
}
.ct-breadcrumb__link:hover {
  color: rgb(0, 173, 208);
  text-decoration: none;
}
.ct-breadcrumb__sep {
  color: #ccc;
}
.ct-breadcrumb__current {
  color: #6d6e71;
  font-weight: 600;
}
.ct-breadcrumb__step {
  font-weight: 600;
  color: #6d6e71;
}
.ct-breadcrumb__shop-link {
  margin-left: auto;
  color: rgb(0, 173, 208);
  text-decoration: none;
  font-size: 13px;
  font-weight: 600;
  transition: color 0.15s;
}
.ct-breadcrumb__shop-link:hover {
  color: #00839d;
  text-decoration: none;
}
.ct-breadcrumb__shop-link i {
  margin-right: 4px;
}
@media (max-width: 640px) {
  .ct-breadcrumb__shop-link {
    margin-left: 0;
    width: 100%;
    margin-top: 4px;
  }
}

.ct-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 4px 0 24px;
}
.ct-header__title {
  font-size: 24px;
  font-weight: 700;
  color: #6d6e71;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  margin: 0;
}
.ct-header__title i {
  color: #ccc;
  margin-right: 4px;
}
.ct-header__count {
  font-size: 13px;
  font-weight: 600;
  color: rgb(105, 190, 40);
  background: rgba(105, 190, 40, 0.08);
  padding: 3px 10px;
  border-radius: 10px;
}

.ct-layout {
  display: grid;
  grid-template-columns: 1fr 340px;
  gap: 24px;
  align-items: start;
}
@media (max-width: 991px) {
  .ct-layout {
    grid-template-columns: 1fr;
  }
}
.ct-layout__main {
  min-width: 0;
}
.ct-layout__sidebar {
  min-width: 0;
}

.ct-card {
  background: #fff;
  border: 1px solid #e7eaec;
  border-radius: 10px;
  overflow: hidden;
  margin-bottom: 16px;
}
.ct-card--faded {
  opacity: 0.4;
  pointer-events: none;
}
.ct-card__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 20px;
  border-bottom: 1px solid #e7eaec;
  cursor: pointer;
  transition: background 0.15s;
}
.ct-card__header:hover {
  background: rgba(0, 0, 0, 0.01);
}
.ct-card__header--static {
  cursor: default;
}
.ct-card__header--static:hover {
  background: none;
}
.ct-card__title {
  font-size: 15px;
  font-weight: 700;
  color: #6d6e71;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  margin: 0;
}
.ct-card__title i {
  margin-right: 6px;
  color: #ccc;
  font-size: 14px;
}
.ct-card__subtitle {
  font-weight: 400;
  font-size: 12px;
  color: #ccc;
  margin-left: 4px;
}
.ct-card__badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 24px;
  height: 24px;
  padding: 0 8px;
  border-radius: 12px;
  background: linear-gradient(135deg, rgb(0, 173, 208), #008ba7);
  color: #fff;
  font-size: 12px;
  font-weight: 700;
}

.ct-item {
  display: flex;
  gap: 16px;
  padding: 16px 20px;
  border-bottom: 1px solid #e7eaec;
  align-items: flex-start;
}
.ct-item:last-child {
  border-bottom: none;
}
@media (max-width: 640px) {
  .ct-item {
    flex-wrap: wrap;
  }
}
.ct-item__image {
  width: 72px;
  height: 72px;
  border-radius: 8px;
  overflow: hidden;
  background: #f8f9fa;
  flex-shrink: 0;
  border: 1px solid #e7eaec;
}
.ct-item__image img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  padding: 4px;
}
.ct-item__image--gift {
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(105, 190, 40, 0.05);
  border-color: rgba(105, 190, 40, 0.15);
  color: rgb(105, 190, 40);
  font-size: 22px;
}
.ct-item__body {
  flex: 1;
  min-width: 0;
}
.ct-item__name {
  font-size: 14px;
  font-weight: 600;
  color: #676a6c;
  margin: 0 0 6px;
  cursor: pointer;
  line-height: 1.3;
  transition: color 0.15s;
}
.ct-item__name:hover {
  color: rgb(0, 173, 208);
}
.ct-item__name--comp {
  color: #ccc;
  cursor: pointer;
}
.ct-item__comp-badge {
  display: inline-block;
  font-size: 10px;
  font-weight: 600;
  padding: 2px 6px;
  border-radius: 3px;
  background: rgba(105, 190, 40, 0.08);
  color: rgb(105, 190, 40);
  margin-left: 6px;
  vertical-align: middle;
  text-transform: uppercase;
}
.ct-item__meta {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 14px;
  margin-bottom: 8px;
}
.ct-item__meta span {
  font-size: 12px;
  color: #676a6c;
}
.ct-item__meta span i {
  font-size: 10px;
  color: #ccc;
  margin-right: 3px;
  width: 12px;
  text-align: center;
}
.ct-item__meta--promo {
  color: rgb(105, 190, 40) !important;
}
.ct-item__meta--promo i {
  color: rgb(105, 190, 40) !important;
}
.ct-item__remove {
  border: none;
  background: none;
  font-size: 12px;
  color: #ccc;
  cursor: pointer;
  padding: 0;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  transition: color 0.15s;
}
.ct-item__remove:hover {
  color: rgb(245, 67, 89);
}
.ct-item__remove i {
  margin-right: 3px;
}
.ct-item__pricing {
  display: flex;
  gap: 20px;
  flex-shrink: 0;
  align-items: flex-start;
}
@media (max-width: 640px) {
  .ct-item__pricing {
    width: 100%;
    justify-content: space-between;
    padding-top: 8px;
    border-top: 1px dashed #e7eaec;
  }
}
.ct-item__price-cell {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 60px;
}
.ct-item__price-label {
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #ccc;
  margin-bottom: 4px;
}
.ct-item__price-value {
  font-size: 14px;
  font-weight: 500;
  color: #676a6c;
}
.ct-item__qty-input {
  width: 52px;
  height: 32px;
  border: 1px solid #e7eaec;
  border-radius: 5px;
  text-align: center;
  font-size: 14px;
  color: #676a6c;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  outline: none;
  transition: border-color 0.2s;
}
.ct-item__qty-input:focus {
  border-color: rgb(105, 190, 40);
  box-shadow: 0 0 0 2px rgba(105, 190, 40, 0.1);
}
.ct-item__qty-fixed {
  font-size: 14px;
  font-weight: 500;
  color: #ccc;
}
.ct-item__total {
  font-size: 15px;
  font-weight: 700;
  color: #676a6c;
}

.ct-promo {
  padding: 16px 20px;
}
.ct-promo__form {
  display: flex;
  gap: 8px;
  align-items: center;
}
.ct-promo__input {
  flex: 1;
  max-width: 300px;
  height: 36px;
  padding: 6px 12px;
  border: 1px solid #e7eaec;
  border-radius: 6px;
  font-size: 13px;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  color: #676a6c;
  outline: none;
  transition: border-color 0.2s;
}
.ct-promo__input:focus {
  border-color: rgb(105, 190, 40);
  box-shadow: 0 0 0 2px rgba(105, 190, 40, 0.1);
}
.ct-promo__input::placeholder {
  color: #ccc;
}
.ct-promo__applied {
  font-size: 14px;
  font-weight: 600;
  color: rgb(105, 190, 40);
}
.ct-promo__applied i {
  margin-right: 4px;
}
.ct-promo__remove {
  border: none;
  background: none;
  color: #ccc;
  cursor: pointer;
  font-size: 16px;
  padding: 0 4px;
  transition: color 0.15s;
}
.ct-promo__remove:hover {
  color: rgb(245, 67, 89);
}

.ct-section {
  padding: 16px 20px;
  border-top: 1px solid #e7eaec;
}
.ct-section__heading {
  font-size: 14px;
  font-weight: 700;
  color: #6d6e71;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  margin: 0 0 12px;
}
.ct-section__heading small {
  font-weight: 400;
  color: #ccc;
}

.ct-loader {
  padding: 40px 0;
  text-align: center;
  position: relative;
  min-height: 100px;
}

.ct-adrs-form {
  padding: 0;
}

.ct-adrs-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 12px;
}

.ct-adrs-option {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px 16px;
  border: 1px solid #e7eaec;
  border-radius: 8px;
  cursor: pointer;
  transition: border-color 0.15s, background 0.15s;
  margin: 0;
  font-weight: normal;
}
.ct-adrs-option:hover {
  border-color: #cbd1d5;
  background: #fafafa;
}
.ct-adrs-option--selected {
  border-color: rgb(105, 190, 40);
  background: rgba(105, 190, 40, 0.03);
}
.ct-adrs-option__radio {
  width: 16px;
  height: 16px;
  margin-top: 2px;
  flex-shrink: 0;
  accent-color: rgb(105, 190, 40);
  cursor: pointer;
}
.ct-adrs-option__content {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 1px;
}
.ct-adrs-option__name {
  font-size: 13px;
  font-weight: 600;
  color: #6d6e71;
}
.ct-adrs-option__org {
  font-size: 12px;
  color: #ccc;
}
.ct-adrs-option__line {
  font-size: 12px;
  color: #676a6c;
  line-height: 1.5;
}
.ct-adrs-option__same-badge {
  display: inline-block;
  font-size: 11px;
  font-weight: 600;
  color: rgb(105, 190, 40);
  background: rgba(105, 190, 40, 0.08);
  padding: 1px 8px;
  border-radius: 3px;
  margin-top: 4px;
  width: -moz-fit-content;
  width: fit-content;
}
.ct-adrs-option__edit {
  font-size: 12px;
  color: rgb(0, 173, 208);
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
  text-decoration: none;
  transition: color 0.15s;
}
.ct-adrs-option__edit:hover {
  color: #00839d;
  text-decoration: none;
}
.ct-adrs-option__edit i {
  margin-right: 3px;
}

.ct-adrs-add {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  border: 1px dashed #d0d6da;
  border-radius: 8px;
  background: #fff;
  color: rgb(0, 173, 208);
  font-size: 13px;
  font-weight: 600;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  cursor: pointer;
  transition: border-color 0.15s, background 0.15s;
}
.ct-adrs-add:hover {
  border-color: rgb(0, 173, 208);
  background: rgba(0, 173, 208, 0.03);
}
.ct-adrs-add i {
  font-size: 14px;
}

.ct-adrs-panel {
  margin-top: 16px;
  padding: 20px;
  background: #f9fafb;
  border: 1px solid #e7eaec;
  border-radius: 8px;
}
.ct-adrs-panel__title {
  font-size: 15px;
  font-weight: 700;
  color: #6d6e71;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  margin: 0 0 16px;
}

.ct-adrs-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px 16px;
}
@media (max-width: 640px) {
  .ct-adrs-grid {
    grid-template-columns: 1fr;
  }
}
.ct-adrs-grid__full {
  grid-column: 1/-1;
}
.ct-adrs-grid__half {
  min-width: 0;
}

.ct-adrs-label {
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: #6d6e71;
  margin-bottom: 4px;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
}

.ct-adrs-req {
  color: #e74c3c;
}

.ct-adrs-input,
.ct-adrs-select {
  width: 100%;
  height: 38px;
  padding: 6px 12px;
  border: 1px solid #e7eaec;
  border-radius: 6px;
  font-size: 13px;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  color: #676a6c;
  background: #fff;
  outline: none;
  transition: border-color 0.2s, box-shadow 0.2s;
}
.ct-adrs-input:focus,
.ct-adrs-select:focus {
  border-color: rgb(105, 190, 40);
  box-shadow: 0 0 0 2px rgba(105, 190, 40, 0.1);
}
.ct-adrs-input::placeholder,
.ct-adrs-select::placeholder {
  color: #ccc;
}
.ct-adrs-input:disabled,
.ct-adrs-select:disabled {
  background: #f5f5f5;
  cursor: not-allowed;
  opacity: 0.6;
}

.ct-adrs-select {
  appearance: auto;
  cursor: pointer;
}

.ct-adrs-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 16px;
  padding-bottom: 4px;
}

.ct-ship-alert {
  font-size: 13px;
  color: #ccc;
  font-style: italic;
  margin: 0 0 10px;
}

.ct-ship-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.ct-ship-option {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  border: 1px solid #e7eaec;
  border-radius: 8px;
  cursor: pointer;
  transition: border-color 0.15s, background 0.15s;
  margin: 0;
  font-weight: normal;
}
.ct-ship-option:hover {
  border-color: #cbd1d5;
  background: #fafafa;
}
.ct-ship-option--selected {
  border-color: rgb(105, 190, 40);
  background: rgba(105, 190, 40, 0.03);
}
.ct-ship-option__radio {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  accent-color: rgb(105, 190, 40);
  cursor: pointer;
}
.ct-ship-option__content {
  flex: 1;
  min-width: 0;
}
.ct-ship-option__name {
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: #6d6e71;
}
.ct-ship-option__detail {
  display: block;
  font-size: 12px;
  color: #ccc;
  margin-top: 2px;
}
.ct-ship-option__price {
  font-size: 14px;
  font-weight: 700;
  color: #676a6c;
  white-space: nowrap;
  flex-shrink: 0;
}

.ct-pay {
  padding: 0 20px 16px;
}
.ct-pay__cards {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 16px;
}
.ct-pay__actions {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}
.ct-pay__or {
  font-size: 13px;
  color: #ccc;
}
.ct-pay__paypal {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  border: 1px solid #003087;
  border-radius: 8px;
  background: #fff;
  color: #003087;
  font-size: 13px;
  font-weight: 600;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s;
}
.ct-pay__paypal:hover {
  background: rgba(0, 48, 135, 0.04);
}
.ct-pay__paypal i {
  font-size: 16px;
}

.ct-pay-card {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  border: 1px solid #e7eaec;
  border-radius: 8px;
  cursor: pointer;
  transition: border-color 0.15s, background 0.15s;
  margin: 0;
  font-weight: normal;
}
.ct-pay-card:hover {
  border-color: #cbd1d5;
  background: #fafafa;
}
.ct-pay-card--selected {
  border-color: rgb(105, 190, 40);
  background: rgba(105, 190, 40, 0.03);
}
.ct-pay-card__radio {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  accent-color: rgb(105, 190, 40);
  cursor: pointer;
}
.ct-pay-card__content {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}
.ct-pay-card__icon {
  font-size: 18px;
  color: #ccc;
  flex-shrink: 0;
}
.ct-pay-card__number {
  font-size: 14px;
  font-weight: 500;
  color: #6d6e71;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  letter-spacing: 0.5px;
}
.ct-pay-card__delete {
  border: none;
  background: none;
  color: #ccc;
  font-size: 14px;
  cursor: pointer;
  padding: 4px 6px;
  border-radius: 4px;
  flex-shrink: 0;
  transition: color 0.15s, background 0.15s;
}
.ct-pay-card__delete:hover {
  color: rgb(245, 67, 89);
  background: rgba(245, 67, 89, 0.06);
}

.ct-pay-loader {
  position: relative;
  min-height: 120px;
  padding: 20px;
}

.ct-empty {
  text-align: center;
  padding: 60px 20px;
  background: #fff;
  border: 1px solid #e7eaec;
  border-radius: 10px;
}
.ct-empty__icon {
  font-size: 40px;
  color: #ccc;
  margin-bottom: 12px;
  opacity: 0.4;
}
.ct-empty__title {
  font-size: 18px;
  font-weight: 700;
  color: #676a6c;
  margin: 0 0 4px;
}
.ct-empty__text {
  font-size: 14px;
  color: #ccc;
  margin: 0 0 20px;
}

.ct-summary {
  background: #fff;
  border: 1px solid #e7eaec;
  border-radius: 10px;
  overflow: hidden;
  position: sticky;
  top: 20px;
}
.ct-summary__header {
  padding: 14px 20px;
  background: #6d6e71;
  border-bottom: 1px solid #e7eaec;
}
.ct-summary__header h3 {
  font-size: 15px;
  font-weight: 700;
  color: #fff;
  margin: 0;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
}
.ct-summary__header h3 i {
  margin-right: 6px;
  opacity: 0.7;
}
.ct-summary__body {
  padding: 16px 20px;
}
.ct-summary__item {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 8px 0;
  gap: 12px;
}
.ct-summary__item-info {
  flex: 1;
  min-width: 0;
}
.ct-summary__item-name {
  display: block;
  font-size: 13px;
  font-weight: 500;
  color: #676a6c;
  line-height: 1.3;
  margin-bottom: 2px;
}
.ct-summary__item-qty {
  display: block;
  font-size: 11px;
  color: #ccc;
}
.ct-summary__item-price {
  font-size: 13px;
  font-weight: 600;
  color: #676a6c;
  white-space: nowrap;
}
.ct-summary__divider {
  height: 1px;
  background: #e7eaec;
  margin: 8px 0;
}
.ct-summary__row {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 5px 0;
  font-size: 13px;
  color: #676a6c;
}
.ct-summary__row--bold {
  font-weight: 700;
}
.ct-summary__row--total {
  font-size: 16px;
  font-weight: 700;
  color: #676a6c;
  padding-top: 8px;
}
.ct-summary__row--discount {
  color: rgb(105, 190, 40);
  font-weight: 600;
}
.ct-summary__row--address {
  flex-direction: column;
  gap: 4px;
}
.ct-summary__amount {
  font-weight: 600;
  font-variant-numeric: tabular-nums;
}
.ct-summary__amount--total {
  font-size: 18px;
  color: rgb(105, 190, 40);
}
.ct-summary__address-text {
  font-size: 12px;
  color: #ccc;
  line-height: 1.5;
  display: block;
  width: 100%;
}

.ct-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 9px 20px;
  font-size: 13px;
  font-weight: 600;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  text-decoration: none;
  transition: all 0.2s ease;
  white-space: nowrap;
}
.ct-btn--primary {
  background: rgb(105, 190, 40);
  color: #fff;
  box-shadow: 0 2px 6px rgba(105, 190, 40, 0.2);
}
.ct-btn--primary:hover {
  background: #5ba523;
  box-shadow: 0 4px 12px rgba(105, 190, 40, 0.3);
  color: #fff;
  text-decoration: none;
}
.ct-btn--sm {
  padding: 7px 16px;
  font-size: 12px;
}

.red-text {
  color: red;
}

.error-msg {
  font-size: 14px;
}

.address-form {
  padding-top: 10px;
  padding-left: 15px;
  padding-right: 15px;
}
.address-form .form-group label {
  margin-bottom: 0;
  font-weight: 700;
}

.address-mb {
  margin-top: 15px;
  margin-bottom: 15px;
}

.billing-box {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 20px;
}
@media screen and (max-width: 767px) {
  .billing-box {
    display: block;
  }
}

.list-ship-adrs {
  display: block;
  width: 100%;
  position: relative;
  padding-left: 24px;
}
.list-ship-adrs input[type=radio] {
  display: inline-block;
  width: auto;
  vertical-align: top;
  height: auto;
  margin-top: 5px;
  position: absolute;
  left: 0;
  top: 0;
  min-height: inherit;
}
.list-ship-adrs label {
  display: inline;
  padding-left: 0;
  cursor: pointer;
  vertical-align: middle;
}
@media screen and (max-width: 540px) {
  .list-ship-adrs label {
    vertical-align: top;
    width: 80%;
  }
}
.list-ship-adrs label span {
  vertical-align: middle;
}
.list-ship-adrs a, .list-ship-adrs span {
  vertical-align: middle;
}

.bill-adrs {
  margin-bottom: 15px;
}

.label-shipAdrs {
  font-weight: 400 !important;
}

.list-bold {
  font-weight: bold;
}

.add-shipping {
  display: inline-block;
  padding: 5px 10px 0;
  cursor: pointer;
  background-color: #fff;
  border: 1px dotted #ddd;
  box-shadow: 0 2px 0 #ddd;
  border-radius: 5px;
  font-size: 14px;
  line-height: 1.3;
  -webkit-user-select: none;
          user-select: none;
}
.add-shipping:hover {
  border: 1px solid #ccc;
}
.add-shipping i {
  font-size: 20px;
  padding: 0 15px 0 0;
  float: left;
}
.add-shipping span {
  overflow: hidden;
  display: block;
}

.edit-adrs {
  cursor: pointer;
}

.shipping-inline {
  display: table;
  width: 100%;
}
.shipping-inline .label-shipping {
  display: block;
  vertical-align: top;
  padding-right: 10px;
  width: auto !important;
}
.shipping-inline .label-shipping:first-child {
  padding-top: 10px;
}

.label-shipping {
  width: 100%;
  display: block;
  clear: both;
  margin: 0;
  padding: 10px 0;
  line-height: 1 !important;
  vertical-align: top;
  font-weight: normal;
}
.label-shipping:first-child {
  padding-top: 15px;
}
.label-shipping:last-child {
  padding-bottom: 15px;
}
.label-shipping input {
  float: left;
  margin-top: 4px !important;
}
.label-shipping label {
  float: left;
  padding-left: 10px;
  width: 80%;
  cursor: pointer;
  font-weight: normal;
  line-height: 1.6;
}

.label-shipping input {
  display: inline-block !important;
  width: auto !important;
  vertical-align: top !important;
  margin: 0 !important;
  line-height: normal;
  height: auto !important;
}

.order-info {
  font-weight: normal;
  font-style: italic;
}

.proceed-ship-method {
  padding: 10px;
}

.bottom-cart select, .bottom-cart input {
  margin-bottom: 16px;
  margin-top: 1px;
  min-height: 34px;
}
.bottom-cart select:focus-visible, .bottom-cart input:focus-visible {
  outline: none;
}
.bottom-cart select:focus, .bottom-cart input:focus {
  border: 1px solid #1ab394;
}

.saved-cards-wrap {
  padding-top: 25px;
  padding-left: 15px;
  padding-right: 15px;
}
@media screen and (max-width: 767px) {
  .saved-cards-wrap div[class*=col-]:nth-child(2) {
    padding-top: 20px;
  }
}

.saved-card-list li label {
  padding-left: 15px;
  padding-right: 10px;
  cursor: pointer;
}
.saved-card-list li i {
  cursor: pointer;
}

.new-card label {
  padding-left: 15px;
}

.card-payment {
  min-height: 150px;
  left: 0 !important;
  top: 0 !important;
  position: relative;
}

.ship-methods {
  min-height: 150px;
  left: 0 !important;
  top: 0 !important;
  position: relative;
  padding: 15px;
}

::ng-deep .ibox-content .icheckbox_square-green,
::ng-deep .ibox-content .iradio_square-green {
  display: inline-block;
  *display: inline;
  vertical-align: middle;
  margin: 0;
  padding: 0;
  width: 22px;
  height: 22px;
  background: url("https://assets.foursightonline.com/app/images/green.png") no-repeat;
  border: none;
  cursor: pointer;
}
::ng-deep .ibox-content .icheckbox_square-green {
  background-position: 0 0;
}
::ng-deep .ibox-content .icheckbox_square-green.hover {
  background-position: -24px 0;
}
::ng-deep .ibox-content .icheckbox_square-green.checked {
  background-position: -48px 0;
}
::ng-deep .ibox-content .icheckbox_square-green.disabled {
  background-position: -72px 0;
  cursor: default;
}
::ng-deep .ibox-content .icheckbox_square-green.checked.disabled {
  background-position: -96px 0;
}
::ng-deep .ibox-content .iradio_square-green {
  background-position: -120px 0;
}
::ng-deep .ibox-content .iradio_square-green.hover {
  background-position: -144px 0;
}
::ng-deep .ibox-content .iradio_square-green.checked {
  background-position: -168px 0;
}
::ng-deep .ibox-content .iradio_square-green.disabled {
  background-position: -192px 0;
  cursor: default;
}
::ng-deep .ibox-content .iradio_square-green.checked.disabled {
  background-position: -216px 0;
}
@media (min-resolution: 120dpi) {
  ::ng-deep .ibox-content .icheckbox_square-green,
  ::ng-deep .ibox-content .iradio_square-green {
    background-image: url("https://assets.foursightonline.com/app/images/green@2x.png");
    background-size: 240px 24px;
  }
}

#stripe_error {
  color: #f00;
}

#card_error {
  display: none;
  color: white;
  background-color: red;
  padding: 10px;
}

#stripe_card {
  background: #f2f2f2;
  padding: 20px;
  margin-bottom: 5px !important;
  border-radius: 2px;
  border: 1px solid #ccc;
  box-sizing: border-box;
}

.main-card {
  position: relative;
  padding: 30px;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  width: 100%;
  margin: 0 auto;
}
.main-card input:focus {
  outline: none;
}

.sr-form-row label {
  padding-top: 5px;
  margin-bottom: 0;
  font-weight: 700;
  padding-left: 22px;
}
.sr-form-row label input {
  top: 8px;
  left: 0;
}

.fixed-loader {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 1;
  transform: translate(-50%, -50%);
}

.loader-container {
  position: absolute;
  left: 0;
  right: 0;
  text-align: center;
  top: 0;
  bottom: 0;
  background: rgba(236, 236, 236, 0.9);
  display: none;
  justify-content: center;
  align-items: center;
  z-index: 9999999999;
  height: 100%;
  margin: 0 auto;
}

.loader-spin {
  background-color: hsla(0, 0%, 92.5%, 0.9);
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
}

.loader__inner {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

#Path_129 {
  animation: blink 2s linear infinite;
  opacity: 0;
}

#Path_130 {
  animation: blink 2s linear infinite;
  animation-delay: 0.5s;
  opacity: 0;
}

#Path_132 {
  animation: blink 2s linear infinite;
  animation-delay: 1s;
  opacity: 0;
}

#Path_131 {
  animation: blink 2s linear infinite;
  animation-delay: 1.5s;
  opacity: 0;
}

@keyframes blink {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
::ng-deep.swal2-modal {
  flex-wrap: wrap;
  justify-content: center;
  max-width: 500px !important;
  width: 100% !important;
  left: 0 !important;
  top: 0 !important;
  transform: translate(0, 0) !important;
  margin: auto !important;
  height: 390px;
  box-sizing: border-box !important;
  bottom: 0;
  right: 0;
}

::ng-deep .swal2-show {
  background-color: white;
  font-family: "Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  width: 478px;
  padding: 17px;
  border-radius: 5px;
  text-align: center;
  position: fixed;
  left: 0 !important;
  top: 0 !important;
  transform: translate(0, 0) !important;
  margin-left: -256px;
  overflow: hidden;
  z-index: 99999;
  margin-top: -168px;
}
::ng-deep .swal2-show:focus {
  outline: none;
}
::ng-deep .swal2-show button.swal2-cancel.swal2-styled {
  background-color: #D0D0D0 !important;
  color: white;
  border: none;
  box-shadow: none;
  font-size: 17px;
  font-weight: 500;
  border-radius: 5px;
  padding: 10px 32px;
  margin: 26px 5px 0 5px;
  cursor: pointer;
}
::ng-deep .swal2-show button.swal2-cancel.swal2-styled:focus {
  outline: none;
}
::ng-deep .swal2-show button.swal2-confirm.swal2-styled {
  background-color: #AEDEF4;
  color: white;
  border: none;
  box-shadow: none;
  font-size: 17px;
  font-weight: 500;
  border-radius: 5px;
  padding: 10px 32px;
  margin: 26px 5px 0 5px;
  cursor: pointer;
}
::ng-deep .swal2-show button.swal2-confirm.swal2-styled:focus {
  outline: none;
}
::ng-deep .swal2-show .swal2-icon.swal2-warning {
  width: 80px;
  height: 80px;
  border: 4px solid #F8BB86;
  border-radius: 50%;
  margin: 20px auto;
  padding: 0;
  position: relative;
  box-sizing: content-box;
  font-size: 58px;
  color: #F8BB86;
  justify-content: center;
}
::ng-deep .swal2-show .swal2-icon.swal2-warning:focus {
  outline: none;
}
::ng-deep .swal2-show h2#swal2-title {
  color: #575757;
  font-size: 30px;
  text-align: center;
  font-weight: 600;
  text-transform: none;
  position: relative;
  margin: 25px 0;
  padding: 0;
  line-height: 40px;
  display: block;
}
::ng-deep .swal2-show h2#swal2-title:focus {
  outline: none;
}
::ng-deep .swal2-show div#swal2-content {
  color: #797979;
  font-size: 16px;
  text-align: center;
  font-weight: 300;
  position: relative;
  float: none;
  margin: 0;
  padding: 0;
  line-height: normal;
}
::ng-deep .swal2-show div#swal2-content:focus {
  outline: none;
}

::ng-deep .swal2-shown {
  background-color: rgba(0, 0, 0, 0.4);
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 99999;
}

@media screen and (max-width: 380px) {
  ::ng-deep.swal2-modal {
    height: inherit;
  }
}
::ng-deep.swal2-icon-text {
  font-size: 1.3em;
  line-height: 1;
}

::ng-deep .modal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1050;
  display: none;
  overflow: hidden;
  -webkit-overflow-scrolling: touch;
  outline: 0;
}
::ng-deep .modal.show {
  display: block !important;
}
::ng-deep .modal.grey {
  background: rgba(236, 236, 236, 0.9);
}
::ng-deep .modal.fade .modal-dialog {
  transition: transform 0.3s ease-out;
}
::ng-deep .modal.fade.in {
  opacity: 1;
}
::ng-deep .modal.in .modal-dialog {
  transform: translate(0, 0);
}
::ng-deep .modal.modal-open {
  overflow-x: hidden;
  overflow-y: auto;
}
::ng-deep .modal .modal-dialog {
  position: relative;
  width: auto;
  margin: 10px;
}
@media (min-width: 768px) {
  ::ng-deep .modal .modal-dialog {
    width: 600px;
    margin: 30px auto;
  }
}
::ng-deep .modal .modal-dialog .modal-content {
  background-clip: padding-box;
  background-color: #FFFFFF;
  border: 1px solid rgba(0, 0, 0, 0);
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  outline: 0 none;
  position: relative;
}
::ng-deep .modal .modal-dialog .modal-content .close {
  float: right;
  font-size: 21px;
  font-weight: bold;
  line-height: 1;
  color: #000;
  text-shadow: 0 1px 0 #fff;
  opacity: 0.2;
}
::ng-deep .modal .modal-dialog .modal-content .close:focus-visible {
  outline: none;
}
::ng-deep .modal .modal-dialog .modal-content button.close {
  padding: 0;
  cursor: pointer;
  background: transparent;
  border: 0;
  appearance: none;
}
::ng-deep .modal .modal-dialog .modal-content .modal-body {
  padding: 20px 30px 30px;
  position: relative;
}
::ng-deep .modal .modal-dialog .modal-content .modal-body .rw__cl form .table-responsive table {
  line-height: 20px;
}
::ng-deep .modal .modal-dialog .modal-content .modal-body .rw__cl form .table-responsive table th {
  text-align: left;
}
::ng-deep .modal .modal-dialog .modal-content .modal-body .rw__cl form ul {
  margin-top: 0;
}
::ng-deep .modal .modal-dialog .modal-content .modal-body .rw__cl form .list-group {
  padding-left: 0;
  margin-bottom: 20px;
}
::ng-deep .modal .modal-dialog .modal-content .modal-body .rw__cl form .list-group-item.active, ::ng-deep .modal .modal-dialog .modal-content .modal-body .rw__cl form .list-group-item.active:hover, ::ng-deep .modal .modal-dialog .modal-content .modal-body .rw__cl form .list-group-item.active:focus {
  z-index: 2;
  color: #fff;
  background-color: #337ab7;
  border-color: #337ab7;
  border-radius: 4px;
}
::ng-deep .modal .modal-dialog .modal-content .modal-body .rw__cl form .lbl {
  display: inline-block;
  max-width: 100%;
  margin-bottom: 5px;
  font-weight: 700;
}
::ng-deep .modal .modal-dialog .modal-content .modal-body .rw__cl form .btn-r .f-btn {
  padding: 5px 10px;
  line-height: 1.5;
  font-size: 12px;
}
::ng-deep .modal .modal-dialog .modal-content .modal-body .rw__cl form .btn-r .f-btn--info {
  background-color: #1dc5a3;
  border-color: #1dc5a3;
}
::ng-deep .modal .modal-dialog .modal-content .modal-body.no-pad {
  padding: 0;
}
::ng-deep .modal .f-btn {
  color: #fff;
  font-size: 14px;
  border-color: #73BF38;
  background-color: #73BF38;
}
::ng-deep .modal .f-btn:hover {
  border-color: #4cae4c;
  background-color: #4cae4c;
}
::ng-deep .modal .f-btn--dngr {
  color: #fff;
  border-color: #ED5565;
  background-color: #ED5565;
}
::ng-deep .modal .f-btn--dngr:hover {
  border-color: #ec4758;
  background-color: #ec4758;
}
::ng-deep .modal .f-btn--info {
  color: #fff;
  border-color: #23c6c8;
  background-color: #23c6c8;
}
::ng-deep .modal .f-btn--info:hover {
  border-color: #21b9bb;
  background-color: #21b9bb;
}
::ng-deep .modal .f-btn--wrng {
  color: #fff;
  border-color: #f8ac59;
  background-color: #f8ac59;
}
::ng-deep .modal .f-btn--wrng:hover {
  border-color: #f7a54a;
  background-color: #f7a54a;
}
::ng-deep .modal .hidden {
  display: none;
}

::ng-deep.modal-open {
  overflow: hidden;
}

::ng-deep.card-payment {
  z-index: 99999999 !important;
}
::ng-deep.card-payment .modal-dialog {
  max-width: 400px !important;
}
::ng-deep.card-payment .modal-dialog .modal-body {
  padding: 0 !important;
}

::ng-deep.grey {
  background: rgba(236, 236, 236, 0.9);
}

::ng-deep.box-shadow-cart {
  box-shadow: 0 0 10px -5px #000;
  border-color: #e2e2e2;
}
::ng-deep.box-shadow-cart .bottom-cart {
  box-shadow: none;
}

button.close {
  z-index: 999999;
}

.grey-out {
  background: #676a6c;
  border-color: #676a6c;
  opacity: 0.5;
}

.efulfill-msg {
  padding: 15px 15px 15px 45px;
  background: #6D6E70;
  margin-bottom: 10px;
  position: relative;
  font-family: "Museo-300";
  background-color: #D9D9D9;
}

.paypal img {
  height: auto;
  max-width: 100%;
  cursor: pointer;
}

.tooltipicon {
  position: relative;
  cursor: pointer;
  font-size: 11px;
}
.tooltipicon .tooltiptext {
  visibility: hidden;
  width: 250px;
  background-color: #fff;
  color: #676a6c;
  text-align: left;
  border-radius: 6px;
  padding: 10px;
  box-shadow: 0 0 18px rgba(0, 0, 0, 0.1);
  font-family: "Source Sans Pro", sans-serif;
  font-size: 15px;
  line-height: 1.2em;
  position: absolute;
  top: 15px;
  right: 10px;
  z-index: 1;
}
@media screen and (max-width: 1199px) {
  .tooltipicon .tooltiptext {
    left: auto;
    right: 10px;
  }
}
.tooltipicon:hover .tooltiptext {
  visibility: visible;
}

@media screen and (max-width: 640px) {
  .shipping-inline {
    display: block;
  }
  .shipping-inline label {
    display: block;
  }
}
@media screen and (max-width: 480px) {
  ::ng-deep.jp-card-container {
    width: 100% !important;
    margin-bottom: 10px;
    transform: none !important;
  }
  ::ng-deep.jp-card {
    min-width: inherit !important;
    max-width: 400px;
  }
  .main-card {
    padding: 15px;
    display: block;
  }
}
@media screen and (max-width: 767px) {
  .shipping-adrs .address-form {
    padding-top: 0 !important;
  }
  .shipping-adrs.bottom-cart {
    padding-top: 0 !important;
  }
}
.slds-input {
  background-color: #fff;
  color: #16325c;
  border: 1px solid #d8dde6;
  border-radius: 0.25rem;
  width: 100%;
  transition: border 0.1s linear, background-color 0.1s linear;
  display: inline-block;
  padding: 0 1rem 0 0.75rem;
  line-height: 2.875rem;
  min-height: calc(1.875rem + 2px);
}

.slds-button--brand,
.slds-button_brand {
  padding-left: 1rem;
  padding-right: 1rem;
  text-align: center;
  vertical-align: middle;
  background-color: rgb(105, 190, 40);
  border: 1px solid rgb(105, 190, 40);
  color: #fff;
}

.payment-grid {
  position: relative;
}

.disabled {
  pointer-events: none;
  opacity: 0.4;
}

.tab {
  display: table;
  width: 100%;
  padding-left: 0;
  margin-bottom: 0;
  border: 1px solid #ddd;
  text-align: center;
}
.tab li {
  display: table-cell;
  padding: 5px 10px;
  cursor: pointer;
  font-weight: 600;
  vertical-align: middle;
  background-color: rgba(0, 0, 0, 0.07);
}
.tab li.active-block {
  background-color: #fff;
}
.tab li + li {
  border-left: 1px solid #ddd;
}
.tab li img {
  margin-right: 5px;
  vertical-align: middle;
}

.note-block {
  margin-top: 20px;
  background: #f5f5f5;
  padding: 15px;
}
.note-block strong {
  font-size: 16px;
  margin-bottom: 10px;
  display: inline-block;
}
.note-block ol {
  padding-left: 25px !important;
}
.note-block ol li + li {
  margin-top: 10px;
}

.tab-content .tab-content-inner {
  padding-top: 20px;
}
.tab-content .pt-2 {
  padding-top: 20px;
}
.tab-content h2 {
  margin: 0 0 5px;
  line-height: 32px;
  font-size: 20px;
  font-weight: 400;
}
.tab-content ol {
  padding-left: 15px;
}
.tab-content .orange-btn {
  padding: 12px 20px;
  background-color: rgb(226, 95, 31);
  color: #fff;
  text-transform: capitalize;
  display: inline-block;
  border-radius: 3px;
}

.modal-body {
  padding-top: 30px;
}
.modal-body button.close {
  position: absolute;
  right: 10px;
  top: 10px;
}

.btn-address {
  background-color: #6d6e71;
  color: white;
  opacity: 0.6;
}
.btn-address.active {
  background-color: rgb(105, 190, 40);
  opacity: 1;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/app/components/store/store-cart/store-cart.component.scss"],"names":[],"mappings":"AAgIA;EACE,eAAA;AC/HF;;ADkIA;EACE,aAAA;EACA,eAAA;AC/HF;;ADkIA;EACE,sBAAA;AC/HF;;ADkIA;EACE,8BAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,aAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;AD6IE;;;;;;EAME,YAAA;EACA,wBA7KO;EA8KP,cA3IiB;EA4IjB,0BAAA;EACA,aAAA;AC1IJ;AD4II;;;;;;EACE,gBAAA;ACrIN;ADyIE;;EAEE,eA5GO;EA6GP,gBA3GO;AC5BX;ADyII;EALF;;IAMI,eA/GY;ECtBhB;AACF;ADwIE;;EAEE,eAlHO;EAmHP,gBAjHO;ACrBX;ADwII;EALF;;IAMI,eArHY;ECfhB;AACF;ADuIE;;EAEE,eAxHO;EAyHP,gBAvHO;ACdX;ADuII;EALF;;IAMI,eA3HY;ECRhB;AACF;ADsIE;;EAEE,eA9HO;EA+HP,gBA7HO;ACPX;ADuIE;;EAEE,eAhIO;EAiIP,gBAhIO;ACLX;ADwIE;;EAEE,eAnIO;EAoIP,gBAnIO;ACHX;AD4IE;EACE,eAAA;EACA,gBAAA;EACA,cAzMqB;EA0MrB,aAAA;EACA,mBAAA;AC1IJ;AD4II;EACE,gBAAA;AC1IN;AD6II;EAXF;IAYI,eAAA;EC1IJ;AACF;AD6IE;;EAEE,UAAA;EACA,SAAA;AC3IJ;AD8IE;EACE,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,mBAAA;AC5IJ;;ADgJA;EACE,sBAxNQ;AC2EV;;ADgJA;EACE,iBAlKU;EAmKV,wBAAA;EACA,mBAAA;AC7IF;AD+IE;EALF;IAMI,cAAA;EC5IF;AACF;AD8IE;EACE,iBA1Ka;AC8BjB;AD+IE;EACE,gBApLa;EAqLb,WAAA;AC7IJ;;ADkJE;EACE,kBAAA;AC/IJ;ADkJE;EACE,iBAAA;AChJJ;;ADqJE;EACE,aAAA;AClJJ;;ADsJA;EACE,kBAAA;ACnJF;ADqJE;EACE,mBAAA;ACnJJ;ADuJI;EACE,sBAAA;ACrJN;ADyJE;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,eA9Ne;ACuEnB;ADyJI;EACE,sBAAA;ACvJN;AD0JI;EAVF;IAWI,eApOoB;EC6ExB;AACF;AD0JE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;ACxJJ;AD0JI;EACE,sBAAA;ACxJN;AD2JI;EACE,WAAA;ACzJN;AD4JI;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,4BA5VM;ACkMZ;;AD+JA;EACE,mBA1PO;AC8FT;AD8JE;EAHF;IAII,mBAAA;EC3JF;AACF;AD6JE;EACE,mBAAA;AC3JJ;AD8JE;EACE,aArQK;ACyGT;AD8JI;EAHF;IAII,aAAA;EC3JJ;AACF;AD6JI;EACE,aAAA;AC3JN;;ADgKA;EACE,gBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,+CAAA;EACA,mBAAA;EACA,kBAAA;AC7JF;AD+JE;EACE,eAAA;AC7JJ;ADgKE;EACE,sCAAA;AC9JJ;ADiKE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,oNAAA;AC/JJ;;AD8KE;EACE,eAAA;EACA,gBAAA;EACA,cA/XqB;EAgYrB,gBAAA;EACA,kBAAA;EACA,kBAAA;AC3KJ;AD6KI;EACE,kBAAA;AC3KN;AD8KI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,mCAAA;AC5KN;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,+BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,mBAAA;EACA,oBAAA;EACA,mCAzbc;EA0bd,WAzZS;EA0ZT,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAhdS;EAidT,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iCAAA;AC9KF;ADgLE;EACE,2BAAA;EACA,mBAAA;AC9KJ;ADiLE;EACE,yBAzbiB;EA0bjB,WA1aO;AC2PX;ADkLE;EACE,eAAA;EACA,mBAAA;EACA,oBAAA;AChLJ;ADmLE;EACE,yBAjckB;EAkclB,cArciB;ACoRrB;ADoLE;EACE,yBAvbS;EAwbT,WA1bO;ACwQX;ADoLI;EACE,6BAAA;AClLN;;ADuLA;EACE;IACE,uBAAA;ECpLF;EDuLA;IACE,yBAAA;ECrLF;AACF;ADwLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,+BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,qBAAA;ACtLF;;ADyLA;EACE,UAAA;ACtLF;ADwLE;EACE,qBAAA;ACtLJ;;AD0LA;EACE,UAAA;ACvLF;;AD2LE;EACE,YAAA;EACA,oCAAA;EAEA,aAAA;EACA,eAAA;EACA,gCAAA;ACzLJ;AD4LM;EACE,mBAAA;AC1LR;AD+LE;EACE,2BAAA;AC7LJ;ADgME;EACE,uBAAA;AC9LJ;ADiME;EACE,mBAAA;AC/LJ;;ADoME;EACE,mBAAA;ACjMJ;ADoME;EACE,yBAAA;AClMJ;ADqME;EACE,sBAAA;ACnMJ;ADsME;EACE,uBAAA;ACpMJ;ADuME;EACE,oBAAA;ACrMJ;;AA3YA;EACE,oBAAA;EACA,iBAAA;AA8YF;AA5YE;EAJF;IAI8B,oBAAA;EAgZ5B;AACF;AAhZE;EALF;IAK8B,oBAAA;EAoZ5B;AACF;;AAjZA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,eAAA;EACA,wEDlBW;ECmBX,cDgBmB;ECfnB,eAAA;AAoZF;AAlZE;EACE,cDYiB;ECXjB,qBAAA;EACA,uBAAA;AAoZJ;AAnZI;EAAU,uBDLE;ECKqB,qBAAA;AAuZrC;AApZE;EAAS,WDaS;AC0YpB;AArZE;EACE,cDQiB;ECPjB,gBAAA;AAuZJ;AApZE;EACE,gBAAA;EACA,cDEiB;ACoZrB;AAnZE;EACE,iBAAA;EACA,uBDtBY;ECuBZ,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;AAqZJ;AAnZI;EAAU,cAAA;EAAoC,qBAAA;AAuZlD;AArZI;EAAI,iBAAA;AAwZR;AAtZI;EAZF;IAaI,cAAA;IACA,WAAA;IACA,eAAA;EAyZJ;AACF;;AApZA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;AAuZF;AArZE;EACE,eAAA;EACA,gBAAA;EACA,cD/BiB;ECgCjB,wEDxES;ECyET,SAAA;AAuZJ;AArZI;EAAI,WDjCY;ECiCe,iBAAA;AAyZnC;AAtZE;EACE,eAAA;EACA,gBAAA;EACA,wBD1DY;EC2DZ,oCAAA;EACA,iBAAA;EACA,mBAAA;AAwZJ;;AAnZA;EACE,aAAA;EACA,gCAAA;EACA,SAAA;EACA,kBAAA;AAsZF;AApZE;EANF;IAOI,0BAAA;EAuZF;AACF;AArZE;EAAU,YAAA;AAwZZ;AAvZE;EAAa,YAAA;AA0Zf;;AAtZA;EACE,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;AAyZF;AAvZE;EACE,YAAA;EACA,oBAAA;AAyZJ;AAtZE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,gCAAA;EACA,eAAA;EACA,4BAAA;AAwZJ;AAtZI;EAAU,+BAAA;AAyZd;AAvZI;EACE,eAAA;AAyZN;AAxZM;EAAU,gBAAA;AA2ZhB;AAvZE;EACE,eAAA;EACA,gBAAA;EACA,cDhGiB;ECiGjB,wEDzIS;EC0IT,SAAA;AAyZJ;AAvZI;EAAI,iBAAA;EAAmB,WDlGP;ECkGkC,eAAA;AA4ZtD;AAzZE;EACE,gBAAA;EACA,eAAA;EACA,WDxGgB;ECyGhB,gBAAA;AA2ZJ;AAxZE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,8DAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;AA0ZJ;;AArZA;EACE,aAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;EACA,uBAAA;AAwZF;AAtZE;EAAe,mBAAA;AAyZjB;AAvZE;EATF;IAUI,eAAA;EA0ZF;AACF;AAxZE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,yBAAA;AA0ZJ;AAxZI;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;AA0ZN;AAvZI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,oCAAA;EACA,sCAAA;EACA,wBDlLU;ECmLV,eAAA;AAyZN;AArZE;EACE,OAAA;EACA,YAAA;AAuZJ;AApZE;EACE,eAAA;EACA,gBAAA;EACA,cDnLiB;ECoLjB,eAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;AAsZJ;AApZI;EAAU,uBDvME;AC8lBhB;AArZI;EACE,WDrLc;ECsLd,eAAA;AAuZN;AAnZE;EACE,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,oCAAA;EACA,wBDpNY;ECqNZ,gBAAA;EACA,sBAAA;EACA,yBAAA;AAqZJ;AAlZE;EACE,aAAA;EACA,eAAA;EACA,aAAA;EACA,kBAAA;AAoZJ;AAlZI;EACE,eAAA;EACA,cDtNe;AC0mBrB;AAlZM;EACE,eAAA;EACA,WDnNY;ECoNZ,iBAAA;EACA,WAAA;EACA,kBAAA;AAoZR;AAhZI;EACE,mCAAA;AAkZN;AAjZM;EAAI,mCAAA;AAoZV;AAhZE;EACE,YAAA;EACA,gBAAA;EACA,eAAA;EACA,WDpOgB;ECqOhB,eAAA;EACA,UAAA;EACA,wEDjRS;ECkRT,uBAAA;AAkZJ;AAhZI;EAAU,uBD5PI;AC+oBlB;AAjZI;EAAI,iBAAA;AAoZR;AAjZE;EACE,aAAA;EACA,SAAA;EACA,cAAA;EACA,uBAAA;AAmZJ;AAjZI;EANF;IAOI,WAAA;IACA,8BAAA;IACA,gBAAA;IACA,8BAAA;EAoZJ;AACF;AAjZE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;AAmZJ;AAhZE;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,WDzQgB;EC0QhB,kBAAA;AAkZJ;AA/YE;EACE,eAAA;EACA,gBAAA;EACA,cDvRiB;ACwqBrB;AA9YE;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,cDjSiB;ECkSjB,wEDrUS;ECsUT,aAAA;EACA,6BAAA;AAgZJ;AA9YI;EACE,+BDnTU;ECoTV,6CAAA;AAgZN;AA5YE;EACE,eAAA;EACA,gBAAA;EACA,WDxSgB;ACsrBpB;AA3YE;EACE,eAAA;EACA,gBAAA;EACA,cDrTiB;ACksBrB;;AAxYA;EACE,kBAAA;AA2YF;AAzYE;EACE,aAAA;EACA,QAAA;EACA,mBAAA;AA2YJ;AAxYE;EACE,OAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,wED9WS;EC+WT,cD5UiB;EC6UjB,aAAA;EACA,6BAAA;AA0YJ;AAxYI;EACE,+BD7VU;EC8VV,6CAAA;AA0YN;AAvYI;EAAiB,WD9UD;ACwtBpB;AAvYE;EACE,eAAA;EACA,gBAAA;EACA,wBDvWY;ACgvBhB;AAvYI;EAAI,iBAAA;AA0YR;AAvYE;EACE,YAAA;EACA,gBAAA;EACA,WD5VgB;EC6VhB,eAAA;EACA,eAAA;EACA,cAAA;EACA,uBAAA;AAyYJ;AAvYI;EAAU,uBDpXI;AC8vBlB;;AArYA;EACE,kBAAA;EACA,6BAAA;AAwYF;AAtYE;EACE,eAAA;EACA,gBAAA;EACA,cDhXiB;ECiXjB,wEDzZS;EC0ZT,gBAAA;AAwYJ;AAtYI;EACE,gBAAA;EACA,WDpXc;AC4vBpB;;AAnYA;EACE,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;AAsYF;;AAlYA;EACE,UAAA;AAqYF;;AAlYA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,mBAAA;AAqYF;;AAlYA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,gDAAA;EACA,SAAA;EACA,mBAAA;AAqYF;AAnYE;EACE,qBAAA;EACA,mBAAA;AAqYJ;AAlYE;EACE,+BDjbY;ECkbZ,oCAAA;AAoYJ;AAjYE;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,+BD1bY;EC2bZ,eAAA;AAmYJ;AAhYE;EACE,OAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAkYJ;AA/XE;EACE,eAAA;EACA,gBAAA;EACA,cDxbiB;ACyzBrB;AA9XE;EACE,eAAA;EACA,WD3bgB;AC2zBpB;AA7XE;EACE,eAAA;EACA,cDvciB;ECwcjB,gBAAA;AA+XJ;AA5XE;EACE,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,wBD3dY;EC4dZ,oCAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,uBAAA;EAAA,kBAAA;AA8XJ;AA3XE;EACE,eAAA;EACA,uBDveY;ECweZ,eAAA;EACA,mBAAA;EACA,cAAA;EACA,qBAAA;EACA,uBAAA;AA6XJ;AA3XI;EAAU,cAAA;EAAoC,qBAAA;AA+XlD;AA7XI;EAAI,iBAAA;AAgYR;;AA5XA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,0BAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBD5fc;EC6fd,eAAA;EACA,gBAAA;EACA,wEDphBW;ECqhBX,eAAA;EACA,gDAAA;AA+XF;AA7XE;EACE,8BDpgBY;ECqgBZ,mCAAA;AA+XJ;AA5XE;EAAI,eAAA;AA+XN;;AA5XA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;AA+XF;AA7XE;EACE,eAAA;EACA,gBAAA;EACA,cDlgBiB;ECmgBjB,wED3iBS;EC4iBT,gBAAA;AA+XJ;;AA3XA;EACE,aAAA;EACA,8BAAA;EACA,cAAA;AA8XF;AA5XE;EALF;IAMI,0BAAA;EA+XF;AACF;AA7XE;EAAU,iBAAA;AAgYZ;AA/XE;EAAU,YAAA;AAkYZ;;AA/XA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cDzhBmB;EC0hBnB,kBAAA;EACA,wEDnkBW;ACq8Bb;;AA/XA;EAAe,cAAA;AAmYf;;AAjYA;;EAEE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,wEDhlBW;ECilBX,cD9iBmB;EC+iBnB,gBAAA;EACA,aAAA;EACA,8CAAA;AAoYF;AAlYE;;EACE,+BDhkBY;ECikBZ,6CAAA;AAqYJ;AAlYE;;EAAiB,WDjjBC;ACu7BpB;AApYE;;EACE,mBAAA;EACA,mBAAA;EACA,YAAA;AAuYJ;;AAnYA;EACE,gBAAA;EACA,eAAA;AAsYF;;AAnYA;EACE,aAAA;EACA,yBAAA;EACA,QAAA;EACA,gBAAA;EACA,mBAAA;AAsYF;;AAlYA;EACE,eAAA;EACA,WD1kBkB;EC2kBlB,kBAAA;EACA,gBAAA;AAqYF;;AAlYA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAqYF;;AAlYA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,gDAAA;EACA,SAAA;EACA,mBAAA;AAqYF;AAnYE;EACE,qBAAA;EACA,mBAAA;AAqYJ;AAlYE;EACE,+BD1nBY;EC2nBZ,oCAAA;AAoYJ;AAjYE;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,+BDloBY;ECmoBZ,eAAA;AAmYJ;AAhYE;EACE,OAAA;EACA,YAAA;AAkYJ;AA/XE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cD9nBiB;AC+/BrB;AA9XE;EACE,cAAA;EACA,eAAA;EACA,WDloBgB;ECmoBhB,eAAA;AAgYJ;AA7XE;EACE,eAAA;EACA,gBAAA;EACA,cDhpBiB;ECipBjB,mBAAA;EACA,cAAA;AA+XJ;;AA1XA;EACE,oBAAA;AA6XF;AA3XE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,mBAAA;AA6XJ;AA1XE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AA4XJ;AAzXE;EACE,eAAA;EACA,WDnqBgB;AC8hCpB;AAxXE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,wED3tBS;EC4tBT,eAAA;EACA,gDAAA;AA0XJ;AAxXI;EACE,kCAAA;AA0XN;AAvXI;EAAI,eAAA;AA0XR;;AAtXA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,gDAAA;EACA,SAAA;EACA,mBAAA;AAyXF;AAvXE;EACE,qBAAA;EACA,mBAAA;AAyXJ;AAtXE;EACE,+BDluBY;ECmuBZ,oCAAA;AAwXJ;AArXE;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,+BD1uBY;EC2uBZ,eAAA;AAuXJ;AApXE;EACE,OAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;AAsXJ;AAnXE;EACE,eAAA;EACA,WDruBgB;ECsuBhB,cAAA;AAqXJ;AAlXE;EACE,eAAA;EACA,gBAAA;EACA,cD9uBiB;EC+uBjB,wEDvxBS;ECwxBT,qBAAA;AAoXJ;AAjXE;EACE,YAAA;EACA,gBAAA;EACA,WDpvBgB;ECqvBhB,eAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,yCAAA;AAmXJ;AAjXI;EACE,uBD/wBY;ECgxBZ,mCAAA;AAmXN;;AA9WA;EACE,kBAAA;EACA,iBAAA;EACA,aAAA;AAiXF;;AA7WA;EACE,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;AAgXF;AA9WE;EACE,eAAA;EACA,WDnxBgB;ECoxBhB,mBAAA;EACA,YAAA;AAgXJ;AA7WE;EACE,eAAA;EACA,gBAAA;EACA,cDlyBiB;ECmyBjB,eAAA;AA+WJ;AA5WE;EACE,eAAA;EACA,WDjyBgB;ECkyBhB,gBAAA;AA8WJ;;AAzWA;EACE,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,SAAA;AA4WF;AA1WE;EACE,kBAAA;EACA,mBDnzBiB;ECozBjB,gCAAA;AA4WJ;AA1WI;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,SAAA;EACA,wEDn2BO;AC+sCb;AA1WM;EAAI,iBAAA;EAAmB,YAAA;AA8W7B;AA1WE;EACE,kBAAA;AA4WJ;AAzWE;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,cAAA;EACA,SAAA;AA2WJ;AAxWE;EACE,OAAA;EACA,YAAA;AA0WJ;AAvWE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cD31BiB;EC41BjB,gBAAA;EACA,kBAAA;AAyWJ;AAtWE;EACE,cAAA;EACA,eAAA;EACA,WD51BgB;ACosCpB;AArWE;EACE,eAAA;EACA,gBAAA;EACA,cDz2BiB;EC02BjB,mBAAA;AAuWJ;AApWE;EACE,WAAA;EACA,mBDj2BW;ECk2BX,aAAA;AAsWJ;AAnWE;EACE,aAAA;EACA,8BAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,cDz3BiB;AC8tCrB;AAnWI;EACE,gBAAA;AAqWN;AAlWI;EACE,eAAA;EACA,gBAAA;EACA,cDl4Be;ECm4Bf,gBAAA;AAoWN;AAjWI;EACE,wBDn5BU;ECo5BV,gBAAA;AAmWN;AAhWI;EACE,sBAAA;EACA,QAAA;AAkWN;AA9VE;EACE,gBAAA;EACA,kCAAA;AAgWJ;AA9VI;EACE,eAAA;EACA,wBDn6BU;ACmwChB;AA5VE;EACE,eAAA;EACA,WDt5BgB;ECu5BhB,gBAAA;EACA,cAAA;EACA,WAAA;AA8VJ;;AAzVA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,wEDh9BW;ECi9BX,kBAAA;EACA,YAAA;EACA,eAAA;EACA,qBAAA;EACA,yBAAA;EACA,mBAAA;AA4VF;AA1VE;EACE,6BDl8BY;ECm8BZ,WAAA;EACA,6CAAA;AA4VJ;AA1VI;EACE,mBAAA;EACA,8CAAA;EACA,WAAA;EACA,qBAAA;AA4VN;AAxVE;EACE,iBAAA;EACA,eAAA;AA0VJ;;AAlVA;EAAY,UAAA;AAsVZ;;AArVA;EAAa,eAAA;AAyVb;;AAtVA;EACE,iBAAA;EACA,kBAAA;EACA,mBAAA;AAyVF;AAtVI;EACE,gBAAA;EACA,gBAAA;AAwVN;;AAnVA;EACE,gBAAA;EACA,mBAAA;AAsVF;;AAnVA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;AAsVF;AApVE;EALF;IAKyC,cAAA;EAwVvC;AACF;;AAtVA;EACE,cAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;AAyVF;AAvVE;EACE,qBAAA;EACA,WAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,mBAAA;AAyVJ;AAtVE;EACE,eAAA;EACA,eAAA;EACA,eAAA;EACA,sBAAA;AAwVJ;AAtVI;EANF;IAOI,mBAAA;IACA,UAAA;EAyVJ;AACF;AAvVI;EAAO,sBAAA;AA0VX;AAvVE;EAAU,sBAAA;AA0VZ;;AAvVA;EAAa,mBAAA;AA2Vb;;AA1VA;EAAkB,2BAAA;AA8VlB;;AA7VA;EAAa,iBAAA;AAiWb;;AA/VA;EACE,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,sBAAA;EACA,uBAAA;EACA,wBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;UAAA,iBAAA;AAkWF;AAhWE;EAAU,sBAAA;AAmWZ;AAjWE;EAAI,eAAA;EAAiB,mBAAA;EAAqB,WAAA;AAsW5C;AArWE;EAAO,gBAAA;EAAkB,cAAA;AAyW3B;;AAtWA;EAAa,eAAA;AA0Wb;;AAvWA;EACE,cAAA;EACA,WAAA;AA0WF;AAxWE;EACE,cAAA;EACA,mBAAA;EACA,mBAAA;EACA,sBAAA;AA0WJ;AAxWI;EAAgB,iBAAA;AA2WpB;;AAvWA;EACE,WAAA;EACA,cAAA;EACA,WAAA;EACA,SAAA;EACA,eAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;AA0WF;AAxWE;EAAgB,iBAAA;AA2WlB;AA1WE;EAAe,oBAAA;AA6WjB;AA3WE;EACE,WAAA;EACA,0BAAA;AA6WJ;AA1WE;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;AA4WJ;;AAxWA;EACE,gCAAA;EACA,sBAAA;EACA,8BAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;AA2WF;;AAxWA;EACE,mBAAA;EACA,kBAAA;AA2WF;;AAxWA;EAAuB,aAAA;AA4WvB;;AAzWE;EACE,mBAAA;EACA,eAAA;EACA,gBAAA;AA4WJ;AA1WI;EAAkB,aAAA;AA6WtB;AA5WI;EAAU,yBAAA;AA+Wd;;AA1WA;EACE,iBAAA;EACA,kBAAA;EACA,mBAAA;AA6WF;AA3WE;EACE;IAAkC,iBAAA;EA8WpC;AACF;;AA1WE;EAAW,kBAAA;EAAoB,mBAAA;EAAqB,eAAA;AAgXtD;AA/WE;EAAO,eAAA;AAkXT;;AA9WE;EAAQ,kBAAA;AAkXV;;AA/WA;EACE,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;AAkXF;;AA/WA;EACE,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,aAAA;AAkXF;;AA7WE;;EAEE,qBAAA;GAgXF,eA/WE;EACA,sBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,oFAAA;EACA,YAAA;EACA,eAAA;AAgXJ;AA7WE;EAA0B,wBAAA;AAgX5B;AA/WE;EAAgC,4BAAA;AAkXlC;AAjXE;EAAkC,4BAAA;AAoXpC;AAnXE;EAAmC,4BAAA;EAA8B,eAAA;AAuXnE;AAtXE;EAA2C,4BAAA;AAyX7C;AAxXE;EAAuB,6BAAA;AA2XzB;AA1XE;EAA6B,6BAAA;AA6X/B;AA5XE;EAA+B,6BAAA;AA+XjC;AA9XE;EAAgC,6BAAA;EAA+B,eAAA;AAkYjE;AAjYE;EAAwC,6BAAA;AAoY1C;AAlYE;EAGE;;IAEE,mFAAA;IACA,2BAAA;EAkYJ;AACF;;AA7XA;EAAgB,WAAA;AAiYhB;;AA/XA;EACE,aAAA;EACA,YAAA;EACA,qBAAA;EACA,aAAA;AAkYF;;AA/XA;EACE,mBAAA;EACA,aAAA;EACA,6BAAA;EACA,kBAAA;EACA,sBAAA;EACA,sBAAA;AAkYF;;AA/XA;EACE,kBAAA;EACA,aAAA;EACA,yBAAA;EACA,4BAAA;EACA,WAAA;EACA,cAAA;AAkYF;AAhYE;EAAc,aAAA;AAmYhB;;AA/XE;EACE,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;AAkYJ;AAhYI;EAAQ,QAAA;EAAU,OAAA;AAoYtB;;AA/XA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,gCAAA;AAkYF;;AA/XA;EACE,kBAAA;EACA,OAAA;EACA,QAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,oCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,cAAA;AAkYF;;AA/XA;EACE,yCAAA;EACA,eAAA;EACA,OAAA;EACA,MAAA;EACA,SAAA;EACA,QAAA;AAkYF;;AA/XA;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;AAkYF;;AA9XA;EAAY,mCAAA;EAAqC,UAAA;AAmYjD;;AAlYA;EAAY,mCAAA;EAAqC,qBAAA;EAAsB,UAAA;AAwYvE;;AAvYA;EAAY,mCAAA;EAAqC,mBAAA;EAAqB,UAAA;AA6YtE;;AA5YA;EAAY,mCAAA;EAAqC,qBAAA;EAAuB,UAAA;AAkZxE;;AAhZA;EACE;IAAK,UAAA;EAoZL;EAnZA;IAAM,UAAA;EAsZN;EArZA;IAAO,UAAA;EAwZP;AACF;AArZA;EACE,eAAA;EACA,uBAAA;EACA,2BAAA;EACA,sBAAA;EACA,kBAAA;EACA,iBAAA;EACA,qCAAA;EACA,uBAAA;EACA,aAAA;EACA,iCAAA;EACA,SAAA;EACA,QAAA;AAuZF;;AApZA;EACE,uBAAA;EACA,wEAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,qCAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AAuZF;AArZE;EAAU,aAAA;AAwZZ;AAtZE;EACE,oCAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;AAwZJ;AAvZI;EAAU,aAAA;AA0Zd;AAvZE;EACE,yBAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;AAyZJ;AAxZI;EAAU,aAAA;AA2Zd;AAxZE;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,UAAA;EACA,kBAAA;EACA,uBAAA;EACA,eAAA;EACA,cAAA;EACA,uBAAA;AA0ZJ;AAzZI;EAAU,aAAA;AA4Zd;AAzZE;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,cAAA;EACA,UAAA;EACA,iBAAA;EACA,cAAA;AA2ZJ;AA1ZI;EAAU,aAAA;AA6Zd;AA1ZE;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,mBAAA;AA4ZJ;AA3ZI;EAAU,aAAA;AA8Zd;;AA1ZA;EACE,oCAAA;EACA,eAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,cAAA;AA6ZF;;AA1ZA;EACE;IAAwB,eAAA;EA8ZxB;AACF;AA5ZA;EAA4B,gBAAA;EAAkB,cAAA;AAga9C;;AA7ZA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,aAAA;EACA,aAAA;EACA,gBAAA;EACA,iCAAA;EACA,UAAA;AAgaF;AA9ZE;EAAS,yBAAA;AAiaX;AAhaE;EAAS,oCAAA;AAmaX;AAjaE;EAAuB,mCAAA;AAoazB;AAnaE;EAAY,UAAA;AAsad;AAraE;EAAqB,0BAAA;AAwavB;AAvaE;EAAe,kBAAA;EAAoB,gBAAA;AA2arC;AAzaE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;AA2aJ;AAzaI;EALF;IAK8B,YAAA;IAAc,iBAAA;EA8a5C;AACF;AA7aI;EACE,4BAAA;EACA,yBAAA;EACA,kCAAA;EACA,kBAAA;EACA,wCAAA;EACA,eAAA;EACA,kBAAA;AA+aN;AA7aM;EACE,YAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,YAAA;AA+aR;AA9aQ;EAAkB,aAAA;AAib1B;AA9aM;EACE,UAAA;EACA,eAAA;EACA,uBAAA;EACA,SAAA;EACA,gBAAA;AAgbR;AA7aM;EACE,uBAAA;EACA,kBAAA;AA+aR;AA5aU;EACE,iBAAA;AA8aZ;AA7aY;EAAK,gBAAA;AAgbjB;AA7aU;EAAK,aAAA;AAgbf;AA9aU;EACE,eAAA;EACA,mBAAA;AAgbZ;AA9aY;EAGE,UAAA;EACA,WAAA;EACA,yBAAA;EACA,qBAAA;EACA,kBAAA;AA8ad;AA1aU;EACE,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;AA4aZ;AAzaU;EACE,iBAAA;EACA,gBAAA;EACA,eAAA;AA2aZ;AA1aY;EAAU,yBAAA;EAA2B,qBAAA;AA8ajD;AA1aQ;EAAW,UAAA;AA6anB;AAxaE;EACE,WAAA;EACA,eAAA;EACA,qBAAA;EACA,yBAAA;AA0aJ;AAxaI;EAAU,qBAAA;EAAuB,yBAAA;AA4arC;AA3aI;EAAU,WAAA;EAAa,qBAAA;EAAuB,yBAAA;AAgblD;AAhb6E;EAAU,qBAAA;EAAuB,yBAAA;AAob9G;AAnbI;EAAU,WAAA;EAAa,qBAAA;EAAuB,yBAAA;AAwblD;AAxb6E;EAAU,qBAAA;EAAuB,yBAAA;AA4b9G;AA3bI;EAAU,WAAA;EAAa,qBAAA;EAAuB,yBAAA;AAgclD;AAhc6E;EAAU,qBAAA;EAAuB,yBAAA;AAoc9G;AAjcE;EAAU,aAAA;AAocZ;;AAjcA;EAAuB,gBAAA;AAqcvB;;AAncA;EACE,4BAAA;AAscF;AApcE;EACE,2BAAA;AAscJ;AArcI;EAAc,qBAAA;AAwclB;;AApcA;EAAiB,oCAAA;AAwcjB;;AAvcA;EAA4B,8BAAA;EAAgC,qBAAA;AA4c5D;AA5cmF;EAAe,gBAAA;AA+clG;;AA7cA;EAAe,eAAA;AAidf;;AA/cA;EACE,mBDlhDmB;ECmhDnB,qBDnhDmB;ECohDnB,YAAA;AAkdF;;AA9cA;EACE,4BAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,wBAAA;EACA,yBAAA;AAidF;;AA7cA;EACE,YAAA;EACA,eAAA;EACA,eAAA;AAgdF;;AA5cA;EACE,kBAAA;EACA,eAAA;EACA,eAAA;AA+cF;AA7cE;EACE,kBAAA;EACA,YAAA;EACA,sBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,uCAAA;EACA,0CAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;AA+cJ;AA7cI;EAjBF;IAiB0C,UAAA;IAAY,WAAA;EAkdtD;AACF;AAhdE;EAAuB,mBAAA;AAmdzB;;AA/cA;EACE;IACE,cAAA;EAkdF;EAjdE;IAAQ,cAAA;EAodV;AACF;AAjdA;EACE;IACE,sBAAA;IACA,mBAAA;IACA,0BAAA;EAmdF;EAhdA;IACE,6BAAA;IACA,gBAAA;EAkdF;EA/cA;IACE,aAAA;IACA,cAAA;EAidF;AACF;AA9cA;EACE;IAA+B,yBAAA;EAid/B;EAhdA;IAA6B,yBAAA;EAmd7B;AACF;AAhdA;EACE,sBAAA;EACA,cAAA;EACA,yBAAA;EACA,sBAAA;EACA,WAAA;EACA,4DAAA;EACA,qBAAA;EACA,yBAAA;EACA,qBAAA;EACA,gCAAA;AAkdF;;AA/cA;;EAEE,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,sBAAA;EACA,mCDpoDc;ECqoDd,mCAAA;EACA,WAAA;AAkdF;;AA/cA;EAAgB,kBAAA;AAmdhB;;AAhdA;EACE,oBAAA;EACA,YAAA;AAmdF;;AA/cA;EACE,cAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;AAkdF;AAhdE;EACE,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,qCAAA;AAkdJ;AAhdI;EAAiB,sBAAA;AAmdrB;AAldI;EAAS,2BAAA;AAqdb;AApdI;EAAM,iBAAA;EAAmB,sBAAA;AAwd7B;;AApdA;EACE,gBAAA;EACA,mBAAA;EACA,aAAA;AAudF;AArdE;EAAS,eAAA;EAAiB,mBAAA;EAAqB,qBAAA;AA0djD;AAzdE;EAAK,6BAAA;AA4dP;AA5dsC;EAAU,gBAAA;AA+dhD;;AA3dE;EAAqB,iBAAA;AA+dvB;AA9dE;EAAQ,iBAAA;AAieV;AAheE;EAAK,eAAA;EAAiB,iBAAA;EAAmB,eAAA;EAAiB,gBAAA;AAse5D;AAreE;EAAK,kBAAA;AAweP;AAveE;EAAc,kBAAA;EAAoB,kCAAA;EAAoC,WAAA;EAAa,0BAAA;EAA4B,qBAAA;EAAuB,kBAAA;AA+exI;;AA5eA;EACE,iBAAA;AA+eF;AA9eE;EAAe,kBAAA;EAAoB,WAAA;EAAa,SAAA;AAmflD;;AAhfA;EACE,yBD9qDmB;EC+qDnB,YAAA;EACA,YAAA;AAmfF;AAjfE;EACE,mCDpsDY;ECqsDZ,UAAA;AAmfJ","sourcesContent":["// Font\n$font-stack: \"open sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n$muso-100: \"Museo-100\";\n$muso-300: \"Museo-300\";\n$muso-300-i: \"Museo-300Italic\";\n$muso-500: \"Museo-regular\";\n$muso-700: \"Museo-700\";\n$muso-700-i: \"Museo-700Italic\";\n$muso-sans: \"MuseoSans-300\";\n$car-font: \"Marydale\";\n$car-big-font: \"Bangers\", cursive;\n$font-museo: \"Conv_museo-500-webfont\";\n$font-helvetica: \"Helvetica\", \"open sans\";\n$MuseoSansCondensed-300: \"MuseoSansCondensed-300\";\n\n$fwBold: 700;\n\n//Foursight\n// $clarify-color: #06A6CE;\n// $ideate-color: #FF8300;\n// $develop-color: #7BBC43;\n// $implement-color: #FF485C;\n$clarify-color: rgba(0, 173, 208, 1);\n$ideate-color: rgba(255, 121, 0, 1);\n$develop-color: rgba(105, 190, 40, 1);\n$implement-color: rgba(245, 67, 89, 1);\n$low-clarify-color: rgba(0, 173, 208, 1);\n$low-ideate-color: rgba(255, 121, 0, 1);\n$low-develop-color: rgba(105, 190, 40, 1);\n$low-implement-color: rgba(245, 67, 89, 1);\n$profile-connector-color: #656668;\n// Profile Neutral color\n$integrator-color: #e3e3e3;\n// Team Report\n$report-integrator: #a7a7a7;\n// Body text color in reports\n$body-content-color: #676a6c;\n// Learner Map\n$gray-lm: rgba(0, 0, 0, 0.2);\n$border-color: #aaa;\n\n$color-neutral-dark: #6d6e71;\n$color-neutral-dark-500: #6a6a6a;\n$color-neutral-mid: #ccc;\n$color-neutral-light: #f1f1f2;\n$color-neutral-mid-old: #9e9e97;\n$color-dark-green: #4cae4c;\n$color-light-grey: #d9d9d9;\n$color-red: #ff485c;\n\n$color-grey-1: #e7eaec;\n\n$clrGray1: #f6f6f6;\n\n$clrDarkGray1: #ddd;\n\n$clrGrey: #eee;\n$clrWhite: #fff;\n$clrBlack: #000;\n$clrWarning: #f8ac59;\n\n$assets: \"https://assets.foursightonline.com/app\";\n$adminUpload: \"https://assets.foursightonline.com/admin-uploads/docs/\";\n\n$separator: \"\\//\";\n\n$active-class: #017ebc;\n\n// anchor Tag\n$anchor-color: #337ab7;\n\n//Sidebar\n$color-light-type: #fff;\n// submenu background\n$fs-dark-grey: #464646;\n// Hover\n$fs-active-light: #5f5f63;\n$fs-sidenav-bg: #333333;\n$fs-sidenav-hov-bg: #3e3e3f;\n$fs-green: #69be28;\n\n$clrInputAccent: #639935;\n\n$fn-fs-h1: 44px;\n$fn-fs-h1-mobile: 38px;\n$fn-lh-h1: 1.1;\n\n$fn-fs-h2: 38px;\n$fn-fs-h2-mobile: 32px;\n$fn-lh-h2: 1.2;\n\n$fn-fs-h3: 32px;\n$fn-fs-h3-mobile: 24px;\n$fn-lh-h3: 1.2;\n\n$fn-fs-h4: 24px;\n$fn-fs-h4-mobile: 20px;\n$fn-lh-h4: 1.2;\n\n$fn-fs-h5: 18px;\n$fn-lh-h5: 1.2;\n\n$fn-fs-h6: 16px;\n$fn-lh-h6: 1.3;\n\n$fn-title-subtext: 22px;\n$fn-title-subtext-mobile: 18px;\n\n$pageWidth: 1080px;\n$pageWidthSmall: 820px;\n$pageWidthFluid: 1200px;\n\n$secPad: 60px;\n\n$pageWidth: 1080px;\n$pageWidthFluid: 1200px;\n\n$desktop: \"only screen and (max-width: 1600px)\";\n$mac: \"only screen and (max-width: 1350px)\";\n$pc-up: \"only screen and (min-width: 1200px)\";\n$pc: \"only screen and (max-width: 1199px)\";\n$tablet-up: \"only screen and (min-width: 992px)\";\n$tablet: \"only screen and (max-width: 991px)\";\n$mobile-up: \"only screen and (min-width: 768px)\";\n$mobile: \"only screen and (max-width: 767px)\";\n$xl: \"only screen and (max-width: 1440px)\";\n$xl-up: \"only screen and (min-width: 1440px)\";\n\nimg {\n  max-width: 100%;\n}\n\n.flex {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.dir-col {\n  flex-direction: column;\n}\n\n.dir-col-rev {\n  flex-direction: column-reverse;\n}\n\n.mh-full {\n  min-height: 100%;\n}\n\n.mt-auto {\n  margin-top: auto;\n}\n\n.bt-0 {\n  border-top: 0;\n}\n\n.bb-0 {\n  border-bottom: 0;\n}\n\n@mixin headingfont() {\n  font-family: $muso-700 !important;\n  font-weight: normal !important;\n}\n\n@mixin contentfont() {\n  font-family: $muso-300 !important;\n  font-weight: normal !important;\n}\n\n.fn-body {\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    --hGap: 10px;\n    font-family: $muso-700;\n    color: $color-neutral-dark;\n    margin-bottom: var(--hGap);\n    margin-top: 0;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  h1,\n  .h1-text {\n    font-size: $fn-fs-h1;\n    line-height: $fn-lh-h1;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h1-mobile;\n    }\n  }\n\n  h2,\n  .h2-text {\n    font-size: $fn-fs-h2;\n    line-height: $fn-lh-h2;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h2-mobile;\n    }\n  }\n\n  h3,\n  .h3-text {\n    font-size: $fn-fs-h3;\n    line-height: $fn-lh-h3;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h3-mobile;\n    }\n  }\n\n  h4,\n  .h4-text {\n    font-size: $fn-fs-h4;\n    line-height: $fn-lh-h4;\n  }\n\n  h5,\n  .h5-text {\n    font-size: $fn-fs-h5;\n    line-height: $fn-lh-h5;\n  }\n\n  h6,\n  .h6-text {\n    font-size: $fn-fs-h6;\n    line-height: $fn-lh-h6;\n  }\n\n  $fn-title-subtext: 22px;\n  $fn-title-subtext-mobile: 18px;\n\n  p {\n    font-size: 18px;\n    line-height: 1.6;\n    color: $color-neutral-dark-500;\n    margin-top: 0;\n    margin-bottom: 10px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    @media #{$mobile} {\n      font-size: 16px;\n    }\n  }\n\n  ul,\n  ol {\n    padding: 0;\n    margin: 0;\n  }\n\n  sup {\n    font-size: 0.7em;\n    position: relative;\n    top: 5px;\n    display: inline-block;\n    vertical-align: top;\n  }\n}\n\n.bg-grey {\n  background-color: $clrGrey;\n}\n\n.fn-container {\n  max-width: $pageWidth;\n  width: calc(100% - 30px);\n  margin-inline: auto;\n\n  @media #{$tablet-up} {\n    margin-left: 0;\n  }\n\n  &--fluid {\n    max-width: $pageWidthFluid;\n  }\n\n  &--small {\n    max-width: $pageWidthSmall;\n    width: 100%;\n  }\n}\n\n.text {\n  &-center {\n    text-align: center;\n  }\n\n  &-right {\n    text-align: right;\n  }\n}\n\n.d {\n  &-none {\n    display: none;\n  }\n}\n\n.section-title {\n  text-align: center;\n\n  &:not(:last-child) {\n    margin-bottom: calc($secPad - 20px);\n  }\n\n  h2 {\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n  }\n\n  p {\n    max-width: 900px;\n    width: 100%;\n    margin-inline: auto;\n    font-size: $fn-title-subtext;\n\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n\n    @media #{$mobile} {\n      font-size: $fn-title-subtext-mobile;\n    }\n  }\n\n  .section-title__linkcontainer {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n\n    &:not(:last-child) {\n      margin-block-end: 20px;\n    }\n\n    & > * {\n      margin: 5px;\n    }\n\n    .fn-btn {\n      padding-block: 6px;\n      padding-inline: 13px;\n      font-size: 12px;\n      font-family: $muso-sans;\n    }\n  }\n}\n\n.section-padding {\n  padding-block: $secPad;\n\n  @media #{$mobile} {\n    padding-block: ($secPad - 20px);\n  }\n\n  &-small {\n    padding-block: calc($secPad / 2);\n  }\n\n  &-all {\n    padding: $secPad;\n\n    @media #{$mobile} {\n      padding: calc($secPad / 2);\n    }\n\n    &-small {\n      padding: calc($secPad / 2);\n    }\n  }\n}\n\n.headline {\n  --lineSize: 10px;\n  width: fit-content;\n  padding-block-end: calc(10px + var(--lineSize));\n  margin-inline: auto;\n  position: relative;\n\n  &--small-border {\n    --lineSize: 6px;\n  }\n\n  &:not(:last-child) {\n    margin-bottom: calc(var(--hGap) * 2.5);\n  }\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: var(--lineSize);\n    background: linear-gradient(\n      90deg,\n      $clarify-color 0%,\n      $clarify-color 25%,\n      $ideate-color 25%,\n      $ideate-color 50%,\n      $develop-color 50%,\n      $develop-color 75%,\n      $implement-color 75%,\n      $implement-color 100%\n    );\n  }\n}\n\n.custom-list {\n  li {\n    font-size: 18px;\n    line-height: 1.4;\n    color: $color-neutral-dark-500;\n    list-style: none;\n    position: relative;\n    padding-left: 15px;\n\n    &:not(:last-child) {\n      margin-bottom: 4px;\n    }\n\n    &::before {\n      content: \"\";\n      position: absolute;\n      top: 10px;\n      left: 0;\n      width: 3px;\n      height: 3px;\n      background-color: var(--clrProfile);\n    }\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.fn-btn {\n  padding-block: 20px;\n  padding-inline: 28px;\n  background-color: $develop-color;\n  color: $clrWhite;\n  font-size: 18px;\n  line-height: 1.2;\n  display: inline-block;\n  font-family: $muso-700;\n  text-decoration: none;\n  word-break: break-all;\n  text-align: center;\n  transition: background-color 0.3s;\n\n  &:focus {\n    outline: 1px dashed $color-neutral-dark-500;\n    outline-offset: 4px;\n  }\n\n  &:hover {\n    background-color: $color-neutral-dark;\n    color: $clrWhite;\n  }\n\n  &--sm {\n    font-size: 14px;\n    padding-block: 10px;\n    padding-inline: 20px;\n  }\n\n  &--grey {\n    background-color: $color-neutral-light;\n    color: $color-neutral-dark;\n  }\n\n  &--ongoing {\n    background-color: $clrWarning;\n    color: $clrWhite;\n\n    i {\n      animation: spin 0.3s infinite;\n    }\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.w-4 {\n  width: calc(100% / 3);\n}\n\n.w-3 {\n  width: calc(100% / 4);\n\n  &--wd {\n    width: calc(100% / 3);\n  }\n}\n\n.w-6 {\n  width: calc(100% / 2);\n}\n\n.fn {\n  &-row {\n    --rGap: 15px;\n    --rGap-minus: calc(-1 * var(--rGap));\n\n    display: flex;\n    flex-wrap: wrap;\n    margin-inline: var(--rGap-minus);\n\n    &--col-gap-exist {\n      .fn-col {\n        margin-bottom: calc($secPad / 2);\n      }\n    }\n  }\n\n  &-col {\n    padding-inline: var(--rGap);\n  }\n\n  &-justify-center {\n    justify-content: center;\n  }\n\n  &-items-center {\n    align-items: center;\n  }\n}\n\n.m {\n  &x-auto {\n    margin-inline: auto;\n  }\n\n  &l-auto {\n    margin-inline-start: auto;\n  }\n\n  &l-0 {\n    margin-inline-start: 0;\n  }\n\n  &r-auto {\n    margin-inline-end: auto;\n  }\n\n  &r-0 {\n    margin-inline-end: 0;\n  }\n}\n","$assets: 'https://assets.foursightonline.com/app';\n@import './../../../../assets/styles/variables';\n\n// ── Page ──────────────────────────────────────────────────────\n.ct-page {\n  padding: 0 48px 48px;\n  max-width: 1400px;\n\n  @media (max-width: 991px) { padding: 0 28px 36px; }\n  @media (max-width: 640px) { padding: 0 16px 28px; }\n}\n\n// ── Breadcrumb ────────────────────────────────────────────────\n.ct-breadcrumb {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 16px 0;\n  font-size: 13px;\n  font-family: $font-stack;\n  color: $body-content-color;\n  flex-wrap: wrap;\n\n  &__link {\n    color: $body-content-color;\n    text-decoration: none;\n    transition: color 0.15s;\n    &:hover { color: $clarify-color; text-decoration: none; }\n  }\n\n  &__sep { color: $color-neutral-mid; }\n\n  &__current {\n    color: $color-neutral-dark;\n    font-weight: 600;\n  }\n\n  &__step {\n    font-weight: 600;\n    color: $color-neutral-dark;\n  }\n\n  &__shop-link {\n    margin-left: auto;\n    color: $clarify-color;\n    text-decoration: none;\n    font-size: 13px;\n    font-weight: 600;\n    transition: color 0.15s;\n\n    &:hover { color: darken($clarify-color, 10%); text-decoration: none; }\n\n    i { margin-right: 4px; }\n\n    @media (max-width: 640px) {\n      margin-left: 0;\n      width: 100%;\n      margin-top: 4px;\n    }\n  }\n}\n\n// ── Header ────────────────────────────────────────────────────\n.ct-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin: 4px 0 24px;\n\n  &__title {\n    font-size: 24px;\n    font-weight: 700;\n    color: $color-neutral-dark;\n    font-family: $font-stack;\n    margin: 0;\n\n    i { color: $color-neutral-mid; margin-right: 4px; }\n  }\n\n  &__count {\n    font-size: 13px;\n    font-weight: 600;\n    color: $develop-color;\n    background: rgba($develop-color, 0.08);\n    padding: 3px 10px;\n    border-radius: 10px;\n  }\n}\n\n// ── Layout ────────────────────────────────────────────────────\n.ct-layout {\n  display: grid;\n  grid-template-columns: 1fr 340px;\n  gap: 24px;\n  align-items: start;\n\n  @media (max-width: 991px) {\n    grid-template-columns: 1fr;\n  }\n\n  &__main { min-width: 0; }\n  &__sidebar { min-width: 0; }\n}\n\n// ── Card Container ────────────────────────────────────────────\n.ct-card {\n  background: #fff;\n  border: 1px solid $color-grey-1;\n  border-radius: 10px;\n  overflow: hidden;\n  margin-bottom: 16px;\n\n  &--faded {\n    opacity: 0.4;\n    pointer-events: none;\n  }\n\n  &__header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 14px 20px;\n    border-bottom: 1px solid $color-grey-1;\n    cursor: pointer;\n    transition: background 0.15s;\n\n    &:hover { background: rgba(0, 0, 0, 0.01); }\n\n    &--static {\n      cursor: default;\n      &:hover { background: none; }\n    }\n  }\n\n  &__title {\n    font-size: 15px;\n    font-weight: 700;\n    color: $color-neutral-dark;\n    font-family: $font-stack;\n    margin: 0;\n\n    i { margin-right: 6px; color: $color-neutral-mid; font-size: 14px; }\n  }\n\n  &__subtitle {\n    font-weight: 400;\n    font-size: 12px;\n    color: $color-neutral-mid;\n    margin-left: 4px;\n  }\n\n  &__badge {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    min-width: 24px;\n    height: 24px;\n    padding: 0 8px;\n    border-radius: 12px;\n    background: linear-gradient(135deg, $clarify-color, darken($clarify-color, 8%));\n    color: #fff;\n    font-size: 12px;\n    font-weight: 700;\n  }\n}\n\n// ── Cart Item ─────────────────────────────────────────────────\n.ct-item {\n  display: flex;\n  gap: 16px;\n  padding: 16px 20px;\n  border-bottom: 1px solid $color-grey-1;\n  align-items: flex-start;\n\n  &:last-child { border-bottom: none; }\n\n  @media (max-width: 640px) {\n    flex-wrap: wrap;\n  }\n\n  &__image {\n    width: 72px;\n    height: 72px;\n    border-radius: 8px;\n    overflow: hidden;\n    background: #f8f9fa;\n    flex-shrink: 0;\n    border: 1px solid $color-grey-1;\n\n    img {\n      width: 100%;\n      height: 100%;\n      object-fit: contain;\n      padding: 4px;\n    }\n\n    &--gift {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      background: rgba($develop-color, 0.05);\n      border-color: rgba($develop-color, 0.15);\n      color: $develop-color;\n      font-size: 22px;\n    }\n  }\n\n  &__body {\n    flex: 1;\n    min-width: 0;\n  }\n\n  &__name {\n    font-size: 14px;\n    font-weight: 600;\n    color: $body-content-color;\n    margin: 0 0 6px;\n    cursor: pointer;\n    line-height: 1.3;\n    transition: color 0.15s;\n\n    &:hover { color: $clarify-color; }\n\n    &--comp {\n      color: $color-neutral-mid;\n      cursor: pointer;\n    }\n  }\n\n  &__comp-badge {\n    display: inline-block;\n    font-size: 10px;\n    font-weight: 600;\n    padding: 2px 6px;\n    border-radius: 3px;\n    background: rgba($develop-color, 0.08);\n    color: $develop-color;\n    margin-left: 6px;\n    vertical-align: middle;\n    text-transform: uppercase;\n  }\n\n  &__meta {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 4px 14px;\n    margin-bottom: 8px;\n\n    span {\n      font-size: 12px;\n      color: $body-content-color;\n\n      i {\n        font-size: 10px;\n        color: $color-neutral-mid;\n        margin-right: 3px;\n        width: 12px;\n        text-align: center;\n      }\n    }\n\n    &--promo {\n      color: $develop-color !important;\n      i { color: $develop-color !important; }\n    }\n  }\n\n  &__remove {\n    border: none;\n    background: none;\n    font-size: 12px;\n    color: $color-neutral-mid;\n    cursor: pointer;\n    padding: 0;\n    font-family: $font-stack;\n    transition: color 0.15s;\n\n    &:hover { color: $implement-color; }\n\n    i { margin-right: 3px; }\n  }\n\n  &__pricing {\n    display: flex;\n    gap: 20px;\n    flex-shrink: 0;\n    align-items: flex-start;\n\n    @media (max-width: 640px) {\n      width: 100%;\n      justify-content: space-between;\n      padding-top: 8px;\n      border-top: 1px dashed $color-grey-1;\n    }\n  }\n\n  &__price-cell {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    min-width: 60px;\n  }\n\n  &__price-label {\n    font-size: 10px;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n    color: $color-neutral-mid;\n    margin-bottom: 4px;\n  }\n\n  &__price-value {\n    font-size: 14px;\n    font-weight: 500;\n    color: $body-content-color;\n  }\n\n  &__qty-input {\n    width: 52px;\n    height: 32px;\n    border: 1px solid $color-grey-1;\n    border-radius: 5px;\n    text-align: center;\n    font-size: 14px;\n    color: $body-content-color;\n    font-family: $font-stack;\n    outline: none;\n    transition: border-color 0.2s;\n\n    &:focus {\n      border-color: $develop-color;\n      box-shadow: 0 0 0 2px rgba($develop-color, 0.1);\n    }\n  }\n\n  &__qty-fixed {\n    font-size: 14px;\n    font-weight: 500;\n    color: $color-neutral-mid;\n  }\n\n  &__total {\n    font-size: 15px;\n    font-weight: 700;\n    color: $body-content-color;\n  }\n}\n\n// ── Promo Code ────────────────────────────────────────────────\n.ct-promo {\n  padding: 16px 20px;\n\n  &__form {\n    display: flex;\n    gap: 8px;\n    align-items: center;\n  }\n\n  &__input {\n    flex: 1;\n    max-width: 300px;\n    height: 36px;\n    padding: 6px 12px;\n    border: 1px solid $color-grey-1;\n    border-radius: 6px;\n    font-size: 13px;\n    font-family: $font-stack;\n    color: $body-content-color;\n    outline: none;\n    transition: border-color 0.2s;\n\n    &:focus {\n      border-color: $develop-color;\n      box-shadow: 0 0 0 2px rgba($develop-color, 0.1);\n    }\n\n    &::placeholder { color: $color-neutral-mid; }\n  }\n\n  &__applied {\n    font-size: 14px;\n    font-weight: 600;\n    color: $develop-color;\n\n    i { margin-right: 4px; }\n  }\n\n  &__remove {\n    border: none;\n    background: none;\n    color: $color-neutral-mid;\n    cursor: pointer;\n    font-size: 16px;\n    padding: 0 4px;\n    transition: color 0.15s;\n\n    &:hover { color: $implement-color; }\n  }\n}\n\n// ── Sections (shipping, billing) ──────────────────────────────\n.ct-section {\n  padding: 16px 20px;\n  border-top: 1px solid $color-grey-1;\n\n  &__heading {\n    font-size: 14px;\n    font-weight: 700;\n    color: $color-neutral-dark;\n    font-family: $font-stack;\n    margin: 0 0 12px;\n\n    small {\n      font-weight: 400;\n      color: $color-neutral-mid;\n    }\n  }\n}\n\n.ct-loader {\n  padding: 40px 0;\n  text-align: center;\n  position: relative;\n  min-height: 100px;\n}\n\n// ── Address Form ─────────────────────────────────────────────\n.ct-adrs-form {\n  padding: 0;\n}\n\n.ct-adrs-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-bottom: 12px;\n}\n\n.ct-adrs-option {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 12px 16px;\n  border: 1px solid $color-grey-1;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: border-color 0.15s, background 0.15s;\n  margin: 0;\n  font-weight: normal;\n\n  &:hover {\n    border-color: darken($color-grey-1, 10%);\n    background: #fafafa;\n  }\n\n  &--selected {\n    border-color: $develop-color;\n    background: rgba($develop-color, 0.03);\n  }\n\n  &__radio {\n    width: 16px;\n    height: 16px;\n    margin-top: 2px;\n    flex-shrink: 0;\n    accent-color: $develop-color;\n    cursor: pointer;\n  }\n\n  &__content {\n    flex: 1;\n    min-width: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 1px;\n  }\n\n  &__name {\n    font-size: 13px;\n    font-weight: 600;\n    color: $color-neutral-dark;\n  }\n\n  &__org {\n    font-size: 12px;\n    color: $color-neutral-mid;\n  }\n\n  &__line {\n    font-size: 12px;\n    color: $body-content-color;\n    line-height: 1.5;\n  }\n\n  &__same-badge {\n    display: inline-block;\n    font-size: 11px;\n    font-weight: 600;\n    color: $develop-color;\n    background: rgba($develop-color, 0.08);\n    padding: 1px 8px;\n    border-radius: 3px;\n    margin-top: 4px;\n    width: fit-content;\n  }\n\n  &__edit {\n    font-size: 12px;\n    color: $clarify-color;\n    cursor: pointer;\n    white-space: nowrap;\n    flex-shrink: 0;\n    text-decoration: none;\n    transition: color 0.15s;\n\n    &:hover { color: darken($clarify-color, 10%); text-decoration: none; }\n\n    i { margin-right: 3px; }\n  }\n}\n\n.ct-adrs-add {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 14px;\n  border: 1px dashed darken($color-grey-1, 8%);\n  border-radius: 8px;\n  background: #fff;\n  color: $clarify-color;\n  font-size: 13px;\n  font-weight: 600;\n  font-family: $font-stack;\n  cursor: pointer;\n  transition: border-color 0.15s, background 0.15s;\n\n  &:hover {\n    border-color: $clarify-color;\n    background: rgba($clarify-color, 0.03);\n  }\n\n  i { font-size: 14px; }\n}\n\n.ct-adrs-panel {\n  margin-top: 16px;\n  padding: 20px;\n  background: #f9fafb;\n  border: 1px solid $color-grey-1;\n  border-radius: 8px;\n\n  &__title {\n    font-size: 15px;\n    font-weight: 700;\n    color: $color-neutral-dark;\n    font-family: $font-stack;\n    margin: 0 0 16px;\n  }\n}\n\n.ct-adrs-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 14px 16px;\n\n  @media (max-width: 640px) {\n    grid-template-columns: 1fr;\n  }\n\n  &__full { grid-column: 1 / -1; }\n  &__half { min-width: 0; }\n}\n\n.ct-adrs-label {\n  display: block;\n  font-size: 12px;\n  font-weight: 600;\n  color: $color-neutral-dark;\n  margin-bottom: 4px;\n  font-family: $font-stack;\n}\n\n.ct-adrs-req { color: #e74c3c; }\n\n.ct-adrs-input,\n.ct-adrs-select {\n  width: 100%;\n  height: 38px;\n  padding: 6px 12px;\n  border: 1px solid $color-grey-1;\n  border-radius: 6px;\n  font-size: 13px;\n  font-family: $font-stack;\n  color: $body-content-color;\n  background: #fff;\n  outline: none;\n  transition: border-color 0.2s, box-shadow 0.2s;\n\n  &:focus {\n    border-color: $develop-color;\n    box-shadow: 0 0 0 2px rgba($develop-color, 0.1);\n  }\n\n  &::placeholder { color: $color-neutral-mid; }\n\n  &:disabled {\n    background: #f5f5f5;\n    cursor: not-allowed;\n    opacity: 0.6;\n  }\n}\n\n.ct-adrs-select {\n  appearance: auto;\n  cursor: pointer;\n}\n\n.ct-adrs-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  margin-top: 16px;\n  padding-bottom: 4px;\n}\n\n// ── Shipping Options ─────────────────────────────────────────\n.ct-ship-alert {\n  font-size: 13px;\n  color: $color-neutral-mid;\n  font-style: italic;\n  margin: 0 0 10px;\n}\n\n.ct-ship-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.ct-ship-option {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 16px;\n  border: 1px solid $color-grey-1;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: border-color 0.15s, background 0.15s;\n  margin: 0;\n  font-weight: normal;\n\n  &:hover {\n    border-color: darken($color-grey-1, 10%);\n    background: #fafafa;\n  }\n\n  &--selected {\n    border-color: $develop-color;\n    background: rgba($develop-color, 0.03);\n  }\n\n  &__radio {\n    width: 16px;\n    height: 16px;\n    flex-shrink: 0;\n    accent-color: $develop-color;\n    cursor: pointer;\n  }\n\n  &__content {\n    flex: 1;\n    min-width: 0;\n  }\n\n  &__name {\n    display: block;\n    font-size: 13px;\n    font-weight: 600;\n    color: $color-neutral-dark;\n  }\n\n  &__detail {\n    display: block;\n    font-size: 12px;\n    color: $color-neutral-mid;\n    margin-top: 2px;\n  }\n\n  &__price {\n    font-size: 14px;\n    font-weight: 700;\n    color: $body-content-color;\n    white-space: nowrap;\n    flex-shrink: 0;\n  }\n}\n\n// ── Payment / Cards ──────────────────────────────────────────\n.ct-pay {\n  padding: 0 20px 16px;\n\n  &__cards {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    margin-bottom: 16px;\n  }\n\n  &__actions {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    flex-wrap: wrap;\n  }\n\n  &__or {\n    font-size: 13px;\n    color: $color-neutral-mid;\n  }\n\n  &__paypal {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    padding: 8px 14px;\n    border: 1px solid #003087;\n    border-radius: 8px;\n    background: #fff;\n    color: #003087;\n    font-size: 13px;\n    font-weight: 600;\n    font-family: $font-stack;\n    cursor: pointer;\n    transition: background 0.15s, border-color 0.15s;\n\n    &:hover {\n      background: rgba(0, 48, 135, 0.04);\n    }\n\n    i { font-size: 16px; }\n  }\n}\n\n.ct-pay-card {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 16px;\n  border: 1px solid $color-grey-1;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: border-color 0.15s, background 0.15s;\n  margin: 0;\n  font-weight: normal;\n\n  &:hover {\n    border-color: darken($color-grey-1, 10%);\n    background: #fafafa;\n  }\n\n  &--selected {\n    border-color: $develop-color;\n    background: rgba($develop-color, 0.03);\n  }\n\n  &__radio {\n    width: 16px;\n    height: 16px;\n    flex-shrink: 0;\n    accent-color: $develop-color;\n    cursor: pointer;\n  }\n\n  &__content {\n    flex: 1;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    min-width: 0;\n  }\n\n  &__icon {\n    font-size: 18px;\n    color: $color-neutral-mid;\n    flex-shrink: 0;\n  }\n\n  &__number {\n    font-size: 14px;\n    font-weight: 500;\n    color: $color-neutral-dark;\n    font-family: $font-stack;\n    letter-spacing: 0.5px;\n  }\n\n  &__delete {\n    border: none;\n    background: none;\n    color: $color-neutral-mid;\n    font-size: 14px;\n    cursor: pointer;\n    padding: 4px 6px;\n    border-radius: 4px;\n    flex-shrink: 0;\n    transition: color 0.15s, background 0.15s;\n\n    &:hover {\n      color: $implement-color;\n      background: rgba($implement-color, 0.06);\n    }\n  }\n}\n\n.ct-pay-loader {\n  position: relative;\n  min-height: 120px;\n  padding: 20px;\n}\n\n// ── Empty State ───────────────────────────────────────────────\n.ct-empty {\n  text-align: center;\n  padding: 60px 20px;\n  background: #fff;\n  border: 1px solid $color-grey-1;\n  border-radius: 10px;\n\n  &__icon {\n    font-size: 40px;\n    color: $color-neutral-mid;\n    margin-bottom: 12px;\n    opacity: 0.4;\n  }\n\n  &__title {\n    font-size: 18px;\n    font-weight: 700;\n    color: $body-content-color;\n    margin: 0 0 4px;\n  }\n\n  &__text {\n    font-size: 14px;\n    color: $color-neutral-mid;\n    margin: 0 0 20px;\n  }\n}\n\n// ── Summary Sidebar ───────────────────────────────────────────\n.ct-summary {\n  background: #fff;\n  border: 1px solid $color-grey-1;\n  border-radius: 10px;\n  overflow: hidden;\n  position: sticky;\n  top: 20px;\n\n  &__header {\n    padding: 14px 20px;\n    background: $color-neutral-dark;\n    border-bottom: 1px solid $color-grey-1;\n\n    h3 {\n      font-size: 15px;\n      font-weight: 700;\n      color: #fff;\n      margin: 0;\n      font-family: $font-stack;\n\n      i { margin-right: 6px; opacity: 0.7; }\n    }\n  }\n\n  &__body {\n    padding: 16px 20px;\n  }\n\n  &__item {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    padding: 8px 0;\n    gap: 12px;\n  }\n\n  &__item-info {\n    flex: 1;\n    min-width: 0;\n  }\n\n  &__item-name {\n    display: block;\n    font-size: 13px;\n    font-weight: 500;\n    color: $body-content-color;\n    line-height: 1.3;\n    margin-bottom: 2px;\n  }\n\n  &__item-qty {\n    display: block;\n    font-size: 11px;\n    color: $color-neutral-mid;\n  }\n\n  &__item-price {\n    font-size: 13px;\n    font-weight: 600;\n    color: $body-content-color;\n    white-space: nowrap;\n  }\n\n  &__divider {\n    height: 1px;\n    background: $color-grey-1;\n    margin: 8px 0;\n  }\n\n  &__row {\n    display: flex;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    padding: 5px 0;\n    font-size: 13px;\n    color: $body-content-color;\n\n    &--bold {\n      font-weight: 700;\n    }\n\n    &--total {\n      font-size: 16px;\n      font-weight: 700;\n      color: $body-content-color;\n      padding-top: 8px;\n    }\n\n    &--discount {\n      color: $develop-color;\n      font-weight: 600;\n    }\n\n    &--address {\n      flex-direction: column;\n      gap: 4px;\n    }\n  }\n\n  &__amount {\n    font-weight: 600;\n    font-variant-numeric: tabular-nums;\n\n    &--total {\n      font-size: 18px;\n      color: $develop-color;\n    }\n  }\n\n  &__address-text {\n    font-size: 12px;\n    color: $color-neutral-mid;\n    line-height: 1.5;\n    display: block;\n    width: 100%;\n  }\n}\n\n// ── Buttons ───────────────────────────────────────────────────\n.ct-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 9px 20px;\n  font-size: 13px;\n  font-weight: 600;\n  font-family: $font-stack;\n  border-radius: 6px;\n  border: none;\n  cursor: pointer;\n  text-decoration: none;\n  transition: all 0.2s ease;\n  white-space: nowrap;\n\n  &--primary {\n    background: $develop-color;\n    color: #fff;\n    box-shadow: 0 2px 6px rgba($develop-color, 0.2);\n\n    &:hover {\n      background: darken($develop-color, 6%);\n      box-shadow: 0 4px 12px rgba($develop-color, 0.3);\n      color: #fff;\n      text-decoration: none;\n    }\n  }\n\n  &--sm {\n    padding: 7px 16px;\n    font-size: 12px;\n  }\n}\n\n// ═══════════════════════════════════════════════════════════════\n// LEGACY STYLES (preserved for checkout form functionality)\n// ═══════════════════════════════════════════════════════════════\n\n.red-text { color: red; }\n.error-msg { font-size: 14px; }\n\n// Address forms\n.address-form {\n  padding-top: 10px;\n  padding-left: 15px;\n  padding-right: 15px;\n\n  .form-group {\n    label {\n      margin-bottom: 0;\n      font-weight: 700;\n    }\n  }\n}\n\n.address-mb {\n  margin-top: 15px;\n  margin-bottom: 15px;\n}\n\n.billing-box {\n  display: flex;\n  flex-wrap: wrap;\n  margin-bottom: 20px;\n\n  @media screen and (max-width: 767px) { display: block; }\n}\n\n.list-ship-adrs {\n  display: block;\n  width: 100%;\n  position: relative;\n  padding-left: 24px;\n\n  input[type=\"radio\"] {\n    display: inline-block;\n    width: auto;\n    vertical-align: top;\n    height: auto;\n    margin-top: 5px;\n    position: absolute;\n    left: 0;\n    top: 0;\n    min-height: inherit;\n  }\n\n  label {\n    display: inline;\n    padding-left: 0;\n    cursor: pointer;\n    vertical-align: middle;\n\n    @media screen and (max-width: 540px) {\n      vertical-align: top;\n      width: 80%;\n    }\n\n    span { vertical-align: middle; }\n  }\n\n  a, span { vertical-align: middle; }\n}\n\n.bill-adrs { margin-bottom: 15px; }\n.label-shipAdrs { font-weight: 400 !important; }\n.list-bold { font-weight: bold; }\n\n.add-shipping {\n  display: inline-block;\n  padding: 5px 10px 0;\n  cursor: pointer;\n  background-color: #fff;\n  border: 1px dotted #ddd;\n  box-shadow: 0 2px 0 #ddd;\n  border-radius: 5px;\n  font-size: 14px;\n  line-height: 1.3;\n  user-select: none;\n\n  &:hover { border: 1px solid #ccc; }\n\n  i { font-size: 20px; padding: 0 15px 0 0; float: left; }\n  span { overflow: hidden; display: block; }\n}\n\n.edit-adrs { cursor: pointer; }\n\n// Shipping\n.shipping-inline {\n  display: table;\n  width: 100%;\n\n  .label-shipping {\n    display: block;\n    vertical-align: top;\n    padding-right: 10px;\n    width: auto !important;\n\n    &:first-child { padding-top: 10px; }\n  }\n}\n\n.label-shipping {\n  width: 100%;\n  display: block;\n  clear: both;\n  margin: 0;\n  padding: 10px 0;\n  line-height: 1 !important;\n  vertical-align: top;\n  font-weight: normal;\n\n  &:first-child { padding-top: 15px; }\n  &:last-child { padding-bottom: 15px; }\n\n  input {\n    float: left;\n    margin-top: 4px !important;\n  }\n\n  label {\n    float: left;\n    padding-left: 10px;\n    width: 80%;\n    cursor: pointer;\n    font-weight: normal;\n    line-height: 1.6;\n  }\n}\n\n.label-shipping input {\n  display: inline-block !important;\n  width: auto !important;\n  vertical-align: top !important;\n  margin: 0 !important;\n  line-height: normal;\n  height: auto !important;\n}\n\n.order-info {\n  font-weight: normal;\n  font-style: italic;\n}\n\n.proceed-ship-method { padding: 10px; }\n\n.bottom-cart {\n  select, input {\n    margin-bottom: 16px;\n    margin-top: 1px;\n    min-height: 34px;\n\n    &:focus-visible { outline: none; }\n    &:focus { border: 1px solid #1ab394; }\n  }\n}\n\n// Saved cards\n.saved-cards-wrap {\n  padding-top: 25px;\n  padding-left: 15px;\n  padding-right: 15px;\n\n  @media screen and (max-width: 767px) {\n    div[class*=\"col-\"]:nth-child(2) { padding-top: 20px; }\n  }\n}\n\n.saved-card-list {\n  li label { padding-left: 15px; padding-right: 10px; cursor: pointer; }\n  li i { cursor: pointer; }\n}\n\n.new-card {\n  label { padding-left: 15px; }\n}\n\n.card-payment {\n  min-height: 150px;\n  left: 0 !important;\n  top: 0 !important;\n  position: relative;\n}\n\n.ship-methods {\n  min-height: 150px;\n  left: 0 !important;\n  top: 0 !important;\n  position: relative;\n  padding: 15px;\n}\n\n// iCheck plugin\n::ng-deep .ibox-content {\n  .icheckbox_square-green,\n  .iradio_square-green {\n    display: inline-block;\n    *display: inline;\n    vertical-align: middle;\n    margin: 0;\n    padding: 0;\n    width: 22px;\n    height: 22px;\n    background: url($assets+'/images/green.png') no-repeat;\n    border: none;\n    cursor: pointer;\n  }\n\n  .icheckbox_square-green { background-position: 0 0; }\n  .icheckbox_square-green.hover { background-position: -24px 0; }\n  .icheckbox_square-green.checked { background-position: -48px 0; }\n  .icheckbox_square-green.disabled { background-position: -72px 0; cursor: default; }\n  .icheckbox_square-green.checked.disabled { background-position: -96px 0; }\n  .iradio_square-green { background-position: -120px 0; }\n  .iradio_square-green.hover { background-position: -144px 0; }\n  .iradio_square-green.checked { background-position: -168px 0; }\n  .iradio_square-green.disabled { background-position: -192px 0; cursor: default; }\n  .iradio_square-green.checked.disabled { background-position: -216px 0; }\n\n  @media (-o-min-device-pixel-ratio: 5/4),\n  (-webkit-min-device-pixel-ratio: 1.25),\n  (min-resolution: 120dpi) {\n    .icheckbox_square-green,\n    .iradio_square-green {\n      background-image: url($assets+'/images/green@2x.png');\n      background-size: 240px 24px;\n    }\n  }\n}\n\n// Stripe\n#stripe_error { color: #f00; }\n\n#card_error {\n  display: none;\n  color: white;\n  background-color: red;\n  padding: 10px;\n}\n\n#stripe_card {\n  background: #f2f2f2;\n  padding: 20px;\n  margin-bottom: 5px !important;\n  border-radius: 2px;\n  border: 1px solid #ccc;\n  box-sizing: border-box;\n}\n\n.main-card {\n  position: relative;\n  padding: 30px;\n  padding-top: 0 !important;\n  padding-bottom: 0 !important;\n  width: 100%;\n  margin: 0 auto;\n\n  input:focus { outline: none; }\n}\n\n.sr-form-row {\n  label {\n    padding-top: 5px;\n    margin-bottom: 0;\n    font-weight: 700;\n    padding-left: 22px;\n\n    input { top: 8px; left: 0; }\n  }\n}\n\n// Loaders\n.fixed-loader {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  z-index: 1;\n  transform: translate(-50%, -50%);\n}\n\n.loader-container {\n  position: absolute;\n  left: 0;\n  right: 0;\n  text-align: center;\n  top: 0;\n  bottom: 0;\n  background: rgba(236, 236, 236, .9);\n  display: none;\n  justify-content: center;\n  align-items: center;\n  z-index: 9999999999;\n  height: 100%;\n  margin: 0 auto;\n}\n\n.loader-spin {\n  background-color: hsla(0, 0%, 92.5%, .9);\n  position: fixed;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  right: 0;\n}\n\n.loader__inner {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n}\n\n// Loader animation\n#Path_129 { animation: blink 2s linear infinite; opacity: 0; }\n#Path_130 { animation: blink 2s linear infinite; animation-delay: .5s; opacity: 0; }\n#Path_132 { animation: blink 2s linear infinite; animation-delay: 1s; opacity: 0; }\n#Path_131 { animation: blink 2s linear infinite; animation-delay: 1.5s; opacity: 0; }\n\n@keyframes blink {\n  0% { opacity: 0; }\n  50% { opacity: 1; }\n  100% { opacity: 0; }\n}\n\n// SweetAlert overrides\n::ng-deep.swal2-modal {\n  flex-wrap: wrap;\n  justify-content: center;\n  max-width: 500px !important;\n  width: 100% !important;\n  left: 0 !important;\n  top: 0 !important;\n  transform: translate(0, 0) !important;\n  margin: auto !important;\n  height: 390px;\n  box-sizing: border-box !important;\n  bottom: 0;\n  right: 0;\n}\n\n::ng-deep .swal2-show {\n  background-color: white;\n  font-family: 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;\n  width: 478px;\n  padding: 17px;\n  border-radius: 5px;\n  text-align: center;\n  position: fixed;\n  left: 0 !important;\n  top: 0 !important;\n  transform: translate(0, 0) !important;\n  margin-left: -256px;\n  overflow: hidden;\n  z-index: 99999;\n  margin-top: -168px;\n\n  &:focus { outline: none; }\n\n  button.swal2-cancel.swal2-styled {\n    background-color: #D0D0D0 !important;\n    color: white;\n    border: none;\n    box-shadow: none;\n    font-size: 17px;\n    font-weight: 500;\n    border-radius: 5px;\n    padding: 10px 32px;\n    margin: 26px 5px 0 5px;\n    cursor: pointer;\n    &:focus { outline: none; }\n  }\n\n  button.swal2-confirm.swal2-styled {\n    background-color: #AEDEF4;\n    color: white;\n    border: none;\n    box-shadow: none;\n    font-size: 17px;\n    font-weight: 500;\n    border-radius: 5px;\n    padding: 10px 32px;\n    margin: 26px 5px 0 5px;\n    cursor: pointer;\n    &:focus { outline: none; }\n  }\n\n  .swal2-icon.swal2-warning {\n    width: 80px;\n    height: 80px;\n    border: 4px solid #F8BB86;\n    border-radius: 50%;\n    margin: 20px auto;\n    padding: 0;\n    position: relative;\n    box-sizing: content-box;\n    font-size: 58px;\n    color: #F8BB86;\n    justify-content: center;\n    &:focus { outline: none; }\n  }\n\n  h2#swal2-title {\n    color: #575757;\n    font-size: 30px;\n    text-align: center;\n    font-weight: 600;\n    text-transform: none;\n    position: relative;\n    margin: 25px 0;\n    padding: 0;\n    line-height: 40px;\n    display: block;\n    &:focus { outline: none; }\n  }\n\n  div#swal2-content {\n    color: #797979;\n    font-size: 16px;\n    text-align: center;\n    font-weight: 300;\n    position: relative;\n    float: none;\n    margin: 0;\n    padding: 0;\n    line-height: normal;\n    &:focus { outline: none; }\n  }\n}\n\n::ng-deep .swal2-shown {\n  background-color: rgba(0, 0, 0, 0.4);\n  position: fixed;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  z-index: 99999;\n}\n\n@media screen and (max-width: 380px) {\n  ::ng-deep.swal2-modal { height: inherit; }\n}\n\n::ng-deep.swal2-icon-text { font-size: 1.3em; line-height: 1; }\n\n// Modal styles\n::ng-deep .modal {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1050;\n  display: none;\n  overflow: hidden;\n  -webkit-overflow-scrolling: touch;\n  outline: 0;\n\n  &.show { display: block !important; }\n  &.grey { background: rgba(236, 236, 236, 0.9); }\n\n  &.fade .modal-dialog { transition: transform 0.3s ease-out; }\n  &.fade.in { opacity: 1; }\n  &.in .modal-dialog { transform: translate(0, 0); }\n  &.modal-open { overflow-x: hidden; overflow-y: auto; }\n\n  .modal-dialog {\n    position: relative;\n    width: auto;\n    margin: 10px;\n\n    @media (min-width: 768px) { width: 600px; margin: 30px auto; }\n\n    .modal-content {\n      background-clip: padding-box;\n      background-color: #FFFFFF;\n      border: 1px solid rgba(0, 0, 0, 0);\n      border-radius: 4px;\n      box-shadow: 0 1px 3px rgb(0 0 0 / 30%);\n      outline: 0 none;\n      position: relative;\n\n      .close {\n        float: right;\n        font-size: 21px;\n        font-weight: bold;\n        line-height: 1;\n        color: #000;\n        text-shadow: 0 1px 0 #fff;\n        opacity: 0.2;\n        &:focus-visible { outline: none; }\n      }\n\n      button.close {\n        padding: 0;\n        cursor: pointer;\n        background: transparent;\n        border: 0;\n        appearance: none;\n      }\n\n      .modal-body {\n        padding: 20px 30px 30px;\n        position: relative;\n\n        .rw__cl form {\n          .table-responsive table {\n            line-height: 20px;\n            th { text-align: left; }\n          }\n\n          ul { margin-top: 0; }\n\n          .list-group {\n            padding-left: 0;\n            margin-bottom: 20px;\n\n            &-item.active,\n            &-item.active:hover,\n            &-item.active:focus {\n              z-index: 2;\n              color: #fff;\n              background-color: #337ab7;\n              border-color: #337ab7;\n              border-radius: 4px;\n            }\n          }\n\n          .lbl {\n            display: inline-block;\n            max-width: 100%;\n            margin-bottom: 5px;\n            font-weight: 700;\n          }\n\n          .btn-r .f-btn {\n            padding: 5px 10px;\n            line-height: 1.5;\n            font-size: 12px;\n            &--info { background-color: #1dc5a3; border-color: #1dc5a3; }\n          }\n        }\n\n        &.no-pad { padding: 0; }\n      }\n    }\n  }\n\n  .f-btn {\n    color: #fff;\n    font-size: 14px;\n    border-color: #73BF38;\n    background-color: #73BF38;\n\n    &:hover { border-color: #4cae4c; background-color: #4cae4c; }\n    &--dngr { color: #fff; border-color: #ED5565; background-color: #ED5565; &:hover { border-color: #ec4758; background-color: #ec4758; } }\n    &--info { color: #fff; border-color: #23c6c8; background-color: #23c6c8; &:hover { border-color: #21b9bb; background-color: #21b9bb; } }\n    &--wrng { color: #fff; border-color: #f8ac59; background-color: #f8ac59; &:hover { border-color: #f7a54a; background-color: #f7a54a; } }\n  }\n\n  .hidden { display: none; }\n}\n\n::ng-deep.modal-open { overflow: hidden; }\n\n::ng-deep.card-payment {\n  z-index: 99999999 !important;\n\n  .modal-dialog {\n    max-width: 400px !important;\n    .modal-body { padding: 0 !important; }\n  }\n}\n\n::ng-deep.grey { background: rgba(236, 236, 236, 0.9); }\n::ng-deep.box-shadow-cart { box-shadow: 0 0 10px -5px #000; border-color: #e2e2e2; .bottom-cart { box-shadow: none; } }\n\nbutton.close { z-index: 999999; }\n\n.grey-out {\n  background: $body-content-color;\n  border-color: $body-content-color;\n  opacity: 0.5;\n}\n\n// E-Fulfillment message\n.efulfill-msg {\n  padding: 15px 15px 15px 45px;\n  background: #6D6E70;\n  margin-bottom: 10px;\n  position: relative;\n  font-family: \"Museo-300\";\n  background-color: #D9D9D9;\n}\n\n// PayPal\n.paypal img {\n  height: auto;\n  max-width: 100%;\n  cursor: pointer;\n}\n\n// Tooltip\n.tooltipicon {\n  position: relative;\n  cursor: pointer;\n  font-size: 11px;\n\n  .tooltiptext {\n    visibility: hidden;\n    width: 250px;\n    background-color: #fff;\n    color: #676a6c;\n    text-align: left;\n    border-radius: 6px;\n    padding: 10px;\n    box-shadow: 0 0 18px rgba(0, 0, 0, .1);\n    font-family: \"Source Sans Pro\", sans-serif;\n    font-size: 15px;\n    line-height: 1.2em;\n    position: absolute;\n    top: 15px;\n    right: 10px;\n    z-index: 1;\n\n    @media screen and (max-width: 1199px) { left: auto; right: 10px; }\n  }\n\n  &:hover .tooltiptext { visibility: visible; }\n}\n\n// Responsive overrides\n@media screen and (max-width: 640px) {\n  .shipping-inline {\n    display: block;\n    label { display: block; }\n  }\n}\n\n@media screen and (max-width: 480px) {\n  ::ng-deep.jp-card-container {\n    width: 100% !important;\n    margin-bottom: 10px;\n    transform: none !important;\n  }\n\n  ::ng-deep.jp-card {\n    min-width: inherit !important;\n    max-width: 400px;\n  }\n\n  .main-card {\n    padding: 15px;\n    display: block;\n  }\n}\n\n@media screen and (max-width: 767px) {\n  .shipping-adrs .address-form { padding-top: 0 !important; }\n  .shipping-adrs.bottom-cart { padding-top: 0 !important; }\n}\n\n// Misc form styles\n.slds-input {\n  background-color: #fff;\n  color: #16325c;\n  border: 1px solid #d8dde6;\n  border-radius: .25rem;\n  width: 100%;\n  transition: border .1s linear, background-color .1s linear;\n  display: inline-block;\n  padding: 0 1rem 0 .75rem;\n  line-height: 2.875rem;\n  min-height: calc(1.875rem + (1px * 2));\n}\n\n.slds-button--brand,\n.slds-button_brand {\n  padding-left: 1rem;\n  padding-right: 1rem;\n  text-align: center;\n  vertical-align: middle;\n  background-color: $develop-color;\n  border: 1px solid $develop-color;\n  color: #fff;\n}\n\n.payment-grid { position: relative; }\n\n// Disabled state for f-btn\n.disabled {\n  pointer-events: none;\n  opacity: 0.4;\n}\n\n// Tab styles (for payment modals)\n.tab {\n  display: table;\n  width: 100%;\n  padding-left: 0;\n  margin-bottom: 0;\n  border: 1px solid #ddd;\n  text-align: center;\n\n  li {\n    display: table-cell;\n    padding: 5px 10px;\n    cursor: pointer;\n    font-weight: 600;\n    vertical-align: middle;\n    background-color: rgba(0, 0, 0, .07);\n\n    &.active-block { background-color: #fff; }\n    & + li { border-left: 1px solid #ddd; }\n    img { margin-right: 5px; vertical-align: middle; }\n  }\n}\n\n.note-block {\n  margin-top: 20px;\n  background: #f5f5f5;\n  padding: 15px;\n\n  strong { font-size: 16px; margin-bottom: 10px; display: inline-block; }\n  ol { padding-left: 25px !important; li + li { margin-top: 10px; } }\n}\n\n.tab-content {\n  .tab-content-inner { padding-top: 20px; }\n  .pt-2 { padding-top: 20px; }\n  h2 { margin: 0 0 5px; line-height: 32px; font-size: 20px; font-weight: 400; }\n  ol { padding-left: 15px; }\n  .orange-btn { padding: 12px 20px; background-color: rgb(226, 95, 31); color: #fff; text-transform: capitalize; display: inline-block; border-radius: 3px; }\n}\n\n.modal-body {\n  padding-top: 30px;\n  button.close { position: absolute; right: 10px; top: 10px; }\n}\n\n.btn-address {\n  background-color: $color-neutral-dark;\n  color: white;\n  opacity: 0.6;\n\n  &.active {\n    background-color: $develop-color;\n    opacity: 1.0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
